import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import commomHeader from '../../assets/img/commonHeader.png'
import tiktok from '../../assets/img/tiktok.png'
import youtube from '../../assets/img/youtube.png'
import commonGuide from '../../assets/img/commonGuide.png'
import detailCart from '../../assets/img/detailCart.png'
import detailOrder from '../../assets/img/detailOrder.png'
import detailOffline from '../../assets/img/detailOffline.png'
import detailTransfer from '../../assets/img/detailTransfer.png'
import detailDomestic from '../../assets/img/detailDomestic.png'
import detailDelivery from '../../assets/img/detailDelivery.png'
import GuideModal from "../../components/web/modal/GuideModal";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

import guidePc1 from '../../assets/img/guidePc1.png'
import guidePc2 from '../../assets/img/guidePc2.png'
import guidePc3 from '../../assets/img/guidePc3.png'
import guidePc4 from '../../assets/img/guidePc4.png'
import guidePc5 from '../../assets/img/guidePc5.png'
import guidePc6 from '../../assets/img/guidePc6.png'
import guidePc7 from '../../assets/img/guidePc7.png'
import guidePc8 from '../../assets/img/guidePc8.png'

import guideOne from '../../assets/img/guideOne.png'
import guideTwo from '../../assets/img/guideTwo.png'
import guideThree from '../../assets/img/guideThree.png'
import guideFour from '../../assets/img/guideFour.png'
import guideFive from '../../assets/img/guideFive.png'
import guideSix from '../../assets/img/guideSix.png'
import axios from '../../services/axiosInstance';
import i18n from "../../i18n";
import SeoHelmet from "../../components/SeoHelmet";
import cartStep1_1 from "../../assets/img/cartStep1_1.png";
import cartStep1_2 from "../../assets/img/cartStep1_2.png";
import salesStep1 from "../../assets/img/salesStep1.png";
import offStep1 from "../../assets/img/offStep1.png";
import transStep1 from "../../assets/img/transStep1.png";
import transStep2 from "../../assets/img/transStep2.png";
import domeStep1 from "../../assets/img/domeStep1.png";
import domeStep3 from "../../assets/img/domeStep3.png";
import delStep1_1 from "../../assets/img/delStep1-1.png";
import delStep1_2 from "../../assets/img/delStep1-2.png";
import commonStep2 from "../../assets/img/commonStep2.png";
import commonStep2cd from "../../assets/img/commonStep2cd.png";
import commonStep3 from "../../assets/img/commonStep3.png";
import commonStep4 from "../../assets/img/commonStep4.png";
import commonStep5 from "../../assets/img/commonStep5.png";
import {Helmet} from "react-helmet-async";

/* ===== [수령완료] 일러스트 (움직이는 파스텔 SVG) =====
 * 컨셉: 문/집 앞에서 예쁘게 패킹된 글로벌 택배를 받고 기뻐하는 귀여운 여성.
 * 서비스별 마지막 '상품수령' 스텝에서 공통 재사용. 파스텔 고정색 + CSS 키프레임 애니메이션. */
const RcvScene = ({t}) => (
    <svg className="cg-svg rcv-svg" viewBox="0 0 560 300" role="img" aria-label="receiving a global parcel at the door">
        {/* 배경 */}
        <rect x="6" y="6" width="548" height="288" rx="24" fill="#FFF5FB"/>
        <circle className="rcv-sun" cx="486" cy="60" r="34" fill="#FFE6A0"/>
        <ellipse cx="150" cy="66" rx="46" ry="16" fill="#FFFFFF" opacity="0.75"/>
        <ellipse cx="196" cy="76" rx="30" ry="12" fill="#FFFFFF" opacity="0.6"/>
        {/* 바닥 */}
        <path d="M6 236 H554 V270 a24 24 0 0 1 -24 24 H30 a24 24 0 0 1 -24 -24 Z" fill="#EFEAFF"/>
        {/* 집/현관 */}
        <path d="M44 108 L129 58 L214 108 Z" fill="#B7A4F2"/>
        <rect x="56" y="106" width="146" height="130" rx="8" fill="#FFD9E8"/>
        <rect x="56" y="106" width="146" height="130" rx="8" fill="none" stroke="#FFC8DD" strokeWidth="2"/>
        <circle cx="92" cy="150" r="19" fill="#BFE3FF" stroke="#FFFFFF" strokeWidth="3"/>
        <path d="M92 131 v38 M73 150 h38" stroke="#FFFFFF" strokeWidth="3"/>
        <rect x="138" y="150" width="52" height="86" rx="7" fill="#C7B6FF"/>
        <rect x="138" y="150" width="52" height="86" rx="7" fill="none" stroke="#FFFFFF" strokeWidth="3"/>
        <circle cx="180" cy="196" r="3.4" fill="#FFF3D6"/>
        <ellipse cx="164" cy="238" rx="42" ry="7" fill="#FFC98B"/>
        {/* 화분 */}
        <path d="M206 214 h22 l-3 22 h-16 z" fill="#F5B784"/>
        <path d="M217 214 q-12 -16 -2 -26 q10 8 2 26" fill="#96DCB0"/>
        <path d="M217 214 q12 -12 22 -6 q-6 12 -22 6" fill="#96DCB0"/>
        {/* 반짝이 */}
        <path className="rcv-tw" style={{animationDelay: '0s'}} d="M268 107 L270.6 113.4 L277 116 L270.6 118.6 L268 125 L265.4 118.6 L259 116 L265.4 113.4 Z" fill="#FFD05A"/>
        <path className="rcv-tw" style={{animationDelay: '.7s'}} d="M404 97 L406 102 L411 104 L406 106 L404 111 L402 106 L397 104 L402 102 Z" fill="#C3AEFF"/>
        <path className="rcv-tw" style={{animationDelay: '1.1s'}} d="M300 86 L301.8 90.2 L306 92 L301.8 93.8 L300 98 L298.2 93.8 L294 92 L298.2 90.2 Z" fill="#FFD05A"/>
        <path className="rcv-tw" style={{animationDelay: '1.5s'}} d="M386 150 L387.8 154.2 L392 156 L387.8 157.8 L386 162 L384.2 157.8 L380 156 L384.2 154.2 Z" fill="#8FB4FF"/>
        <path className="rcv-tw" style={{animationDelay: '.4s'}} d="M252 157 L254 162 L259 164 L254 166 L252 171 L250 166 L245 164 L250 162 Z" fill="#FFD05A"/>
        {/* 떠오르는 하트 */}
        <path className="rcv-rise" style={{animationDelay: '0s'}} d="M300 112 C297 106 287 110 300 124 C313 110 303 106 300 112 Z" fill="#FF6F91"/>
        <path className="rcv-rise" style={{animationDelay: '1.5s'}} d="M360 108 C357 102 347 106 360 120 C373 106 363 102 360 108 Z" fill="#FF9DB8"/>
        {/* 여성 */}
        <g className="rcv-bob">
            <ellipse cx="330" cy="240" rx="34" ry="7" fill="#00000010"/>
            <path d="M306 236 L320 176 a10 10 0 0 1 20 0 L354 236 Z" fill="#A7C6FF"/>
            <circle cx="330" cy="150" r="22" fill="#C6A2EC"/>
            <circle cx="330" cy="153" r="17" fill="#FFDCC0"/>
            <path d="M312 153 a18 18 0 0 1 36 0 q0 -21 -18 -21 q-18 0 -18 21 Z" fill="#C6A2EC"/>
            <circle cx="352" cy="150" r="7" fill="#C6A2EC"/>
            <circle cx="320" cy="159" r="3" fill="#FFAAC2"/>
            <circle cx="340" cy="159" r="3" fill="#FFAAC2"/>
            <path d="M321 152 q3.5 4 7 0" fill="none" stroke="#6E6180" strokeWidth="2" strokeLinecap="round"/>
            <path d="M333 152 q3.5 4 7 0" fill="none" stroke="#6E6180" strokeWidth="2" strokeLinecap="round"/>
            <path d="M324 160 q6 6 12 0" fill="none" stroke="#6E6180" strokeWidth="2" strokeLinecap="round"/>
            <path d="M320 182 Q306 186 302 194" fill="none" stroke="#FFDCC0" strokeWidth="8" strokeLinecap="round"/>
            <path d="M340 182 Q354 186 358 194" fill="none" stroke="#FFDCC0" strokeWidth="8" strokeLinecap="round"/>
            <g className="rcv-float">
                <rect x="302" y="182" width="56" height="46" rx="5" fill="#FFF2D6" stroke="#EFBE6E" strokeWidth="2"/>
                <rect x="326" y="182" width="8" height="46" fill="#FF9DB6"/>
                <rect x="302" y="199" width="56" height="8" fill="#FF9DB6"/>
                <circle cx="323" cy="180" r="6" fill="#FF83A4"/>
                <circle cx="337" cy="180" r="6" fill="#FF83A4"/>
                <circle cx="330" cy="181" r="3" fill="#FF6F91"/>
                <circle cx="314" cy="214" r="6.5" fill="#8FB4FF"/>
                <path d="M308 214 h13 M314 208 v13 M310 210 q4 4 0 8 M318 210 q-4 4 0 8" fill="none" stroke="#FFFFFF" strokeWidth="1"/>
                <path d="M346 214 C344 211 339 213 346 220 C353 213 348 211 346 214 Z" fill="#FF6F91"/>
                <circle cx="302" cy="194" r="5" fill="#FFDCC0"/>
                <circle cx="358" cy="194" r="5" fill="#FFDCC0"/>
            </g>
        </g>
        {/* 완료 배지 */}
        <rect x="222" y="250" width="116" height="28" rx="14" fill="#FFFFFF" stroke="#EFE3F3" strokeWidth="1.5"/>
        <circle cx="240" cy="264" r="8.5" fill="#46CE93"/>
        <path d="M236 264 l3 3 5.5 -6.5" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <text x="290" y="269" textAnchor="middle" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="12.5" fill="#6E6180">{t('cgUiShipDone')}</text>
    </svg>
);

/* ===== [구매대행 STEP 2-3] 온라인 쇼핑몰 대신 구매하는 관리자 (움직이는 파스텔 SVG) ===== */
const ShopAgentScene = ({t}) => (
    <svg className="cg-svg rcv-svg" viewBox="0 0 560 300" role="img" aria-label="Btorage staff purchasing online for you">
        <rect x="6" y="6" width="548" height="288" rx="24" fill="#FFF5FB"/>
        <circle className="rcv-sun" cx="502" cy="50" r="24" fill="#FFE6A0"/>
        <ellipse cx="120" cy="54" rx="44" ry="15" fill="#FFFFFF" opacity="0.7"/>
        <ellipse cx="168" cy="64" rx="28" ry="11" fill="#FFFFFF" opacity="0.55"/>
        <path d="M6 238 H554 V270 a24 24 0 0 1 -24 24 H30 a24 24 0 0 1 -24 -24 Z" fill="#EFEAFF"/>
        <rect x="250" y="232" width="264" height="10" rx="5" fill="#E3D9F5"/>
        <path d="M300 208 L470 208 L500 232 L270 232 Z" fill="#E7DEF8" stroke="#D8CBF2" strokeWidth="2"/>
        <rect x="356" y="216" width="58" height="9" rx="4" fill="#D3C6F0"/>
        <rect x="300" y="66" width="176" height="146" rx="12" fill="#FFFFFF" stroke="#E3D9F5" strokeWidth="2"/>
        <rect x="312" y="78" width="152" height="122" rx="7" fill="#FBF6FF"/>
        <rect x="312" y="78" width="152" height="18" rx="7" fill="#F0E9FD"/>
        <circle cx="322" cy="87" r="2.4" fill="#FF9DB6"/>
        <circle cx="331" cy="87" r="2.4" fill="#FFD05A"/>
        <circle cx="340" cy="87" r="2.4" fill="#96DCB0"/>
        <rect x="352" y="82" width="106" height="9" rx="4.5" fill="#FFFFFF"/>
        <text x="360" y="89.6" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="7" fill="#B7A6D8">shop.kr</text>
        <rect x="322" y="108" width="52" height="56" rx="8" fill="#FFE1EC" stroke="#FFC8DD" strokeWidth="1.5"/>
        <path d="M340 122 l6 -5 8 0 6 5 6 5 -5 5 v20 h-20 v-20 l-6 -5 z" fill="#FF9DB6"/>
        <text x="384" y="122" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="11" fill="#6E6180">Hoodie</text>
        <text x="384" y="140" fontFamily="sans-serif" fontSize="9.5" fill="#A38FC4">&#8361; 59,000</text>
        <rect x="384" y="150" width="66" height="20" rx="10" fill="#FF83A4"/>
        <text x="417" y="164" textAnchor="middle" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="9" fill="#FFFFFF">BUY NOW</text>
        <path d="M432 170 l0 18 4.5 -4.5 3.5 8 3.5 -1.5 -3.5 -8 6 0 z" fill="#6E6180"/>
        <g className="rcv-float">
            <circle cx="240" cy="92" r="24" fill="#FFFFFF" stroke="#FFD9EC" strokeWidth="2"/>
            <path d="M228 82 h4 l3 15 h13 l3 -11 h-16" fill="none" stroke="#FF83A4" strokeWidth="2.4" strokeLinejoin="round" strokeLinecap="round"/>
            <circle cx="236" cy="101" r="2.2" fill="#FF83A4"/>
            <circle cx="246" cy="101" r="2.2" fill="#FF83A4"/>
        </g>
        <g className="rcv-bob">
            <ellipse cx="150" cy="236" rx="40" ry="7" fill="#000000" fillOpacity="0.06"/>
            <path d="M110 236 v-34 a40 40 0 0 1 80 0 v34 z" fill="#A7C6FF"/>
            <rect x="132" y="150" width="36" height="14" rx="3" fill="#FFFFFF" stroke="#E3D9F5" strokeWidth="1"/>
            <text x="150" y="160.5" textAnchor="middle" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="8" fill="#8FB4FF">STAFF</text>
            <circle cx="150" cy="118" r="22" fill="#FFDCC0"/>
            <path d="M127 118 a23 23 0 0 1 46 0 q0 -26 -23 -26 q-23 0 -23 26 Z" fill="#C6A2EC"/>
            <path d="M122 120 Q150 90 178 120" fill="none" stroke="#8FB4FF" strokeWidth="4" strokeLinecap="round"/>
            <rect x="116" y="112" width="11" height="16" rx="5" fill="#8FB4FF"/>
            <rect x="173" y="112" width="11" height="16" rx="5" fill="#8FB4FF"/>
            <path d="M120 126 q-6 20 22 21" fill="none" stroke="#8FB4FF" strokeWidth="3" strokeLinecap="round"/>
            <circle cx="143" cy="147" r="3" fill="#8FB4FF"/>
            <circle cx="139" cy="126" r="3" fill="#FFAAC2"/>
            <circle cx="161" cy="126" r="3" fill="#FFAAC2"/>
            <path d="M140 119 q3.5 4 7 0" fill="none" stroke="#6E6180" strokeWidth="2" strokeLinecap="round"/>
            <path d="M153 119 q3.5 4 7 0" fill="none" stroke="#6E6180" strokeWidth="2" strokeLinecap="round"/>
            <path d="M144 129 q6 6 12 0" fill="none" stroke="#6E6180" strokeWidth="2" strokeLinecap="round"/>
            <path d="M186 178 Q236 188 272 214" fill="none" stroke="#FFDCC0" strokeWidth="9" strokeLinecap="round"/>
            <circle cx="273" cy="214" r="5" fill="#FFDCC0"/>
        </g>
        <path className="rcv-tw" style={{animationDelay: '0s'}} d="M210 66 L211.6 71 L216 72.6 L211.6 74.2 L210 79 L208.4 74.2 L204 72.6 L208.4 71 Z" fill="#FFD05A"/>
        <path className="rcv-tw" style={{animationDelay: '.7s'}} d="M286 150 L287.6 155 L292 156.6 L287.6 158.2 L286 163 L284.4 158.2 L280 156.6 L284.4 155 Z" fill="#C3AEFF"/>
        <path className="rcv-tw" style={{animationDelay: '1.2s'}} d="M470 196 L471.6 201 L476 202.6 L471.6 204.2 L470 209 L468.4 204.2 L464 202.6 L468.4 201 Z" fill="#FFD05A"/>
    </svg>
);

/* ===== [오프라인 STEP 2-3] 오프라인 매장 방문해 대신 구매하는 관리자 (움직이는 파스텔 SVG) ===== */
const OfflineAgentScene = ({t}) => (
    <svg className="cg-svg rcv-svg" viewBox="0 0 560 300" role="img" aria-label="Btorage staff buying at an offline store for you">
        <rect x="6" y="6" width="548" height="288" rx="24" fill="#FFF5FB"/>
        <circle className="rcv-sun" cx="504" cy="48" r="22" fill="#FFE6A0"/>
        <ellipse cx="120" cy="52" rx="40" ry="14" fill="#FFFFFF" opacity="0.7"/>
        <path d="M6 238 H554 V270 a24 24 0 0 1 -24 24 H30 a24 24 0 0 1 -24 -24 Z" fill="#EFEAFF"/>
        <rect x="300" y="104" width="200" height="134" rx="8" fill="#FFE1EC"/>
        <rect x="292" y="84" width="216" height="20" rx="5" fill="#FFF2D6"/>
        <rect x="292" y="84" width="27" height="20" fill="#FF9DB6"/>
        <rect x="346" y="84" width="27" height="20" fill="#FF9DB6"/>
        <rect x="400" y="84" width="27" height="20" fill="#FF9DB6"/>
        <rect x="454" y="84" width="27" height="20" fill="#FF9DB6"/>
        <path d="M292 104 q13.5 13 27 0 q13.5 13 27 0 q13.5 13 27 0 q13.5 13 27 0 q13.5 13 27 0 q13.5 13 27 0 q13.5 13 27 0 q13.5 13 27 0 L508 104 Z" fill="#FFCF87"/>
        <rect x="330" y="120" width="140" height="26" rx="6" fill="#FFFFFF" stroke="#FFC8DD" strokeWidth="1.5"/>
        <text x="400" y="138.5" textAnchor="middle" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="14" fill="#C6A2EC">STORE</text>
        <rect x="316" y="158" width="74" height="66" rx="5" fill="#BFE3FF" stroke="#FFFFFF" strokeWidth="2.5"/>
        <path d="M353 158 v66 M316 191 h74" stroke="#FFFFFF" strokeWidth="2.5"/>
        <rect x="408" y="158" width="66" height="80" rx="5" fill="#C7B6FF" stroke="#FFFFFF" strokeWidth="2.5"/>
        <circle cx="418" cy="200" r="3" fill="#FFF3D6"/>
        <rect x="424" y="168" width="30" height="13" rx="3" fill="#FFF2D6" stroke="#FFC98B"/>
        <text x="439" y="177.6" textAnchor="middle" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="7" fill="#FF83A4">OPEN</text>
        <path d="M282 220 h20 l-3 18 h-14 z" fill="#F5B784"/>
        <path d="M292 220 q-10 -14 -2 -22 q8 6 2 22" fill="#96DCB0"/>
        <path d="M292 220 q10 -10 18 -5 q-5 10 -18 5" fill="#96DCB0"/>
        <g className="rcv-bob">
            <ellipse cx="150" cy="240" rx="34" ry="6" fill="#000000" fillOpacity="0.06"/>
            <path d="M150 208 l-14 30" fill="none" stroke="#8FB4E6" strokeWidth="10" strokeLinecap="round"/>
            <path d="M150 208 l13 30" fill="none" stroke="#A7C6FF" strokeWidth="10" strokeLinecap="round"/>
            <path d="M126 214 v-30 a24 24 0 0 1 48 0 v30 z" fill="#A7C6FF"/>
            <rect x="132" y="150" width="36" height="13" rx="3" fill="#FFFFFF" stroke="#E3D9F5" strokeWidth="1"/>
            <text x="150" y="160" textAnchor="middle" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="8" fill="#8FB4FF">STAFF</text>
            <circle cx="150" cy="120" r="21" fill="#FFDCC0"/>
            <path d="M128 120 a22 22 0 0 1 44 0 q0 -25 -22 -25 q-22 0 -22 25 Z" fill="#C6A2EC"/>
            <circle cx="139" cy="127" r="3" fill="#FFAAC2"/>
            <circle cx="161" cy="127" r="3" fill="#FFAAC2"/>
            <path d="M140 120 q3.5 4 7 0" fill="none" stroke="#6E6180" strokeWidth="2" strokeLinecap="round"/>
            <path d="M153 120 q3.5 4 7 0" fill="none" stroke="#6E6180" strokeWidth="2" strokeLinecap="round"/>
            <path d="M144 130 q6 6 12 0" fill="none" stroke="#6E6180" strokeWidth="2" strokeLinecap="round"/>
            <path d="M172 178 Q186 188 190 202" fill="none" stroke="#FFDCC0" strokeWidth="8" strokeLinecap="round"/>
        </g>
        <g className="rcv-float">
            <path d="M182 202 h30 l-4 40 h-22 z" fill="#FF9DB6" stroke="#FF6F91" strokeWidth="1.5"/>
            <path d="M189 202 v-6 a8 8 0 0 1 16 0 v6" fill="none" stroke="#FF6F91" strokeWidth="2"/>
            <path d="M195 216 C193 213 189 215 195 221 C201 215 197 213 195 216 Z" fill="#FFFFFF"/>
            <path d="M208 208 h26 l-3 34 h-20 z" fill="#A7C6FF" stroke="#7FA8E0" strokeWidth="1.5"/>
            <path d="M214 208 v-5 a7 7 0 0 1 14 0 v5" fill="none" stroke="#7FA8E0" strokeWidth="2"/>
        </g>
        <path d="M244 214 q9 -7 18 0" fill="none" stroke="#C7B6FF" strokeWidth="2.4" strokeLinecap="round" strokeDasharray="1 7"/>
        <path className="rcv-tw" style={{animationDelay: '0s'}} d="M250 96 L251.6 101 L256 102.6 L251.6 104.2 L250 109 L248.4 104.2 L244 102.6 L248.4 101 Z" fill="#FFD05A"/>
        <path className="rcv-tw" style={{animationDelay: '.9s'}} d="M476 118 L477.6 123 L482 124.6 L477.6 126.2 L476 131 L474.4 126.2 L470 124.6 L474.4 123 Z" fill="#C3AEFF"/>
    </svg>
);

function UserUsageGuidePg() {

    /** region DataSet */

    const { t } = useTranslation();
    const [theme] = useTheme();

    const [guideData, setGuideData] = useState([]);

    /** endregion DataTable */

    /** region function */

    const [cartGuide, setCartGuide] = useState(false);
    const [orderGuide, setOrderGuide] = useState(true);
    const [offlineGuide, setOfflineGuide] = useState(false);
    const [transferGuide, setTransferGuide] = useState(false);
    const [domesticGuide, setDomesticGuide] = useState(false);
    const [deliveryGuide, setDeliveryGuide] = useState(false);

    const [cartGuidePopup, setCartGuidePopup] = useState(false);
    const [orderGuidePopup, setOrderGuidePopup] = useState(false);
    const [offlineGuidePopup, setOfflineGuidePopup] = useState(false);
    const [transferGuidePopup, setTransferGuidePopup] = useState(false);
    const [domesticGuidePopup, setDomesticGuidePopup] = useState(false);
    const [deliveryGuidePopup, setDeliveryGuidePopup] = useState(false);

    const cartGuideHeader = t('ugHd1');
    const cartGuideContent = t('ugCont1');
    const orderGuideHeader = t('ugHd2');
    const orderGuideContent = t('ugCont2');
    const offlineGuideHeader = t('ugHd3');
    const offlineGuideContent = t('ugCont3');
    const transferGuideHeader = t('ugHd4');
    const transferGuideContent = t('ugCont4');
    const domesticGuideHeader = t('ugHd5');
    const domesticGuideContent = t('ugCont5');
    const deliveryGuideHeader = t('ugHd6');
    const deliveryGuideContent = t('ugCont6');

    const changeSelectedGuide = ((guide) => {
        if (guide === 'cart') {
            setCartGuide(true);
            setOrderGuide(false);
            setOfflineGuide(false);
            setTransferGuide(false);
            setDomesticGuide(false);
            setDeliveryGuide(false);
        } else if (guide === 'order') {
            setCartGuide(false);
            setOrderGuide(true);
            setOfflineGuide(false);
            setTransferGuide(false);
            setDomesticGuide(false);
            setDeliveryGuide(false);
        } else if (guide === 'offline') {
            setCartGuide(false);
            setOrderGuide(false);
            setOfflineGuide(true);
            setTransferGuide(false);
            setDomesticGuide(false);
            setDeliveryGuide(false);
        } else if (guide === 'transfer') {
            setCartGuide(false);
            setOrderGuide(false);
            setOfflineGuide(false);
            setTransferGuide(true);
            setDomesticGuide(false);
            setDeliveryGuide(false);
        } else if (guide === 'domestic') {
            setCartGuide(false);
            setOrderGuide(false);
            setOfflineGuide(false);
            setTransferGuide(false);
            setDomesticGuide(true);
            setDeliveryGuide(false);
        } else if (guide === 'delivery') {
            setCartGuide(false);
            setOrderGuide(false);
            setOfflineGuide(false);
            setTransferGuide(false);
            setDomesticGuide(false);
            setDeliveryGuide(true);
        }
    })

    const openCartGuidePopup = (() => {
        setCartGuidePopup(true);
    })
    const openOrderGuidePopup = (() => {
        setOrderGuidePopup(true);
    })
    const openOfflineGuidePopup = (() => {
        setOfflineGuidePopup(true);
    })
    const openTransferGuidePopup = (() => {
        setTransferGuidePopup(true);
    })
    const openDomesticGuidePopup = (() => {
        setDomesticGuidePopup(true);
    })
    const openDeliveryGuidePopup = (() => {
        setDeliveryGuidePopup(true);
    })
    const closeCartGuidePopup = (() => {
        setCartGuidePopup(false);
    })
    const closeOrderGuidePopup = (() => {
        setOrderGuidePopup(false);
    })
    const closeOfflineGuidePopup = (() => {
        setOfflineGuidePopup(false);
    })
    const closeTransferGuidePopup = (() => {
        setTransferGuidePopup(false);
    })
    const closeDomesticGuidePopup = (() => {
        setDomesticGuidePopup(false);
    })
    const closeDeliveryGuidePopup = (() => {
        setDeliveryGuidePopup(false);
    })

    const groupByType = (guideData) => {
        return guideData.reduce((acc, guide) => {
            const type = guide.gtype;
            if (!acc[type]) {
                acc[type] = [];
            }
            acc[type].push(guide);
            return acc;
        }, {});
    };

    /** endregion function */

    /** region Event */

    useEffect(() => {
        const selectGuideData = (lang) => {
            axios.get(`/guide/selectGuideList?lang=${lang}`)
                .then((response) => {
                    const filteredData = response.data.filter((guide) => guide.gmachineType === "0");
                    const groupedData = groupByType(filteredData);
                    setGuideData(groupedData);
                });
        };

        const currentLanguage = i18n.language || 'ko';
        let lang = '0';

        switch (currentLanguage) {
            case 'en':
                lang = '1';
                break;
            case 'ja':
                lang = '2';
                break;
            case 'zh':
                lang = '3';
                break;
            case 'id':
                lang = '4';
                break;
            default:
                lang = '0';
        }

        selectGuideData(lang.charAt(0));
    }, [i18n.language]);

    const moveToYoutubeLink = () => {
        const lang = i18n.language || 'ko'
        if (lang === 'en') {
            window.open('https://www.youtube.com/watch?v=WBfR96sBKn8', "_blank");
        } else if (lang === 'ja') {
            window.open('https://www.youtube.com/watch?v=ZQJiBi3mj54', "_blank");
        } else if (lang === 'zh') {
            window.open('https://www.youtube.com/watch?v=2KazaZKlgpo', "_blank");
        } else if (lang === 'id') {
            window.open('https://www.youtube.com/watch?v=wQ3IADErJv8', "_blank");
        } else {
            window.open('https://www.youtube.com/watch?v=gs2gt3sew74', "_blank");
        }
    }

    const moveToTiktokLink = () => {
        const lang = i18n.language || 'ko'
        if (lang === 'en') {
            window.open('https://www.tiktok.com/@btorag_e/video/7460468450054425864', "_blank");
        } else if (lang === 'ja') {
            window.open('https://www.tiktok.com/@btorag_e/video/7460468639989304594', "_blank");
        } else if (lang === 'zh') {
            window.open('https://www.tiktok.com/@btorag_e/video/7460468997545413895', "_blank");
        } else if (lang === 'id') {
            window.open('https://www.tiktok.com/@btorag_e/video/7460469385728249096', "_blank");
        } else {
            window.open('https://www.tiktok.com/@btorag_e/video/7460467183391477000', "_blank");
        }
    }

    /** endregion */

    return (
        <div className="up-scope up-page" data-theme={theme}>

            <Helmet>
                <title>이용가이드(Guide)</title>
                <meta name="description" content="더 쉬운 시작을 위한 가이드"/>
                <link rel="canonical" href="https://btorage.com/UserUsageGuidePg"/>
                <meta property="og:url" content="https://btorage.com/UserUsageGuidePg"/>
                <link rel="alternate" hrefLang="ko" href="https://btorage.com/UserUsageGuidePg"/>
                <link rel="alternate" hrefLang="x-default" href="https://btorage.com/UserUsageGuidePg"/>

                <link rel="icon" type="image/png" sizes="32x32" href="/bt_logo.png"/>
                <link rel="apple-touch-icon" href="/bt_logo.png"/>
                <meta property="og:type" content="website"/>
                <meta property="og:image" content="https://btorage.com/linkBanner.jpg"/>
                <meta property="og:image:width" content="1200"/>
                <meta property="og:image:height" content="630"/>
                <meta property="og:site_name" content="비토리지(Btorage)"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:image" content="https://btorage.com/linkBanner.jpg"/>
            </Helmet>

            <div
                style={{display: "flex", alignItems: "flex-start", justifyContent: "space-between", padding: "10px 0"}}>
                <div className="user-center">
                    <img className="wd-25 ht-25" src={commomHeader} alt="header"/>
                    <p className="font-s-20 font-t-title font-c-default"
                       style={{margin: "5px 0 0 10px"}}>{t(`hdSMenu2`)}</p>
                </div>
                <div>
                    <img onClick={moveToYoutubeLink} className="wd-40 ht-40 m-l-10 c-point" style={{opacity:0.6}} src={youtube} alt="Tiktok"/>
                <img onClick={moveToTiktokLink} className="wd-40 ht-40 m-l-10 c-point" style={{opacity:0.6}} src={tiktok} alt="Youtube"/>
                </div>
            </div>
            <div className="display-flex just-cont-sb align-center m-t-20 ug-guide-tabs">
            {/*장바구니가이드*/}
                <div onClick={()=> changeSelectedGuide('cart')} style={{
                    width:"130px",
                    border: cartGuide ? "solid 2px darkorange" : null,
                    cursor:"pointer",
                    padding:"15px",
                    borderRadius:"10px"
                }}>
                    <div className="user-center ht-90">
                        <div className="user-center" style={{width:"80px", height:"70px", backgroundColor:"var(--up-panel)", borderRadius:"10px"}}>
                            <img style={{width:"40px", height:"40px", opacity:"0.7"}} src={detailCart} alt="cart"/>
                        </div>
                    </div>
                    <div className="user-center font-t-cont">
                        <p className="text-center font-s-15">{t('ugCont7')}</p>
                    </div>
                </div>
                {/*구매대행가이드*/}
                <div onClick={()=> changeSelectedGuide('order')} style={{
                    width:"130px",
                    border: orderGuide ? "solid 2px darkorange" : null,
                    cursor:"pointer",
                    padding:"15px",
                    borderRadius:"10px"
                }}>
                    <div className="user-center" style={{height:"90px"}}>
                        <div className="user-center" style={{width:"80px", height:"70px", backgroundColor:"var(--up-panel)", borderRadius:"10px"}}>
                            <img style={{width:"40px", height:"40px", opacity:"0.7"}} src={detailOrder} alt="order"/>
                        </div>
                    </div>
                    <div className="user-center font-t-cont">
                        <p className="text-center font-s-15">{t('ugCont8')}</p>
                    </div>
                </div>
                {/*오프라인가이드*/}
                <div onClick={()=> changeSelectedGuide('offline')} style={{
                    width:"130px",
                    border: offlineGuide ? "solid 2px darkorange" : null,
                    cursor:"pointer",
                    padding:"15px",
                    borderRadius:"10px"
                }}>
                    <div className="user-center" style={{height:"90px"}}>
                        <div className="user-center" style={{width:"80px", height:"70px", backgroundColor:"var(--up-panel)", borderRadius:"10px"}}>
                            <img style={{width:"40px", height:"40px", opacity:"0.7"}} src={detailOffline} alt="offline"/>
                        </div>
                    </div>
                    <div className="user-center font-t-cont">
                        <p className="text-center font-s-15">{t('ugCont9')}</p>
                    </div>
                </div>
                {/*이체대행가이드*/}
                <div onClick={()=> changeSelectedGuide('transfer')} style={{
                    width:"130px",
                    border: transferGuide ? "solid 2px darkorange" : null,
                    cursor:"pointer",
                    padding:"15px",
                    borderRadius:"10px"
                }}>
                    <div className="user-center" style={{height:"90px"}}>
                        <div className="user-center" style={{width:"80px", height:"70px", backgroundColor:"var(--up-panel)", borderRadius:"10px"}}>
                            <img style={{width:"40px", height:"40px", opacity:"0.7"}} src={detailTransfer} alt="transfer"/>
                        </div>
                    </div>
                    <div className="user-center font-t-cont">
                        <p className="text-center font-s-15">{t('ugCont10')}</p>
                    </div>
                </div>
                {/*국내배송가이드*/}
                <div onClick={()=> changeSelectedGuide('domestic')} style={{
                    width:"130px",
                    border: domesticGuide ? "solid 2px darkorange" : null,
                    cursor:"pointer",
                    padding:"15px",
                    borderRadius:"10px"
                }}>
                    <div className="user-center" style={{height:"90px"}}>
                        <div className="user-center" style={{width:"80px", height:"70px", backgroundColor:"var(--up-panel)", borderRadius:"10px"}}>
                            <img style={{width:"40px", height:"40px", opacity:"0.7"}} src={detailDomestic} alt="domestic"/>
                        </div>
                    </div>
                    <div className="user-center font-t-cont">
                        <p className="text-center font-s-15">{t('ugCont11')}</p>
                    </div>
                </div>
                {/*배송대행가이드*/}
                <div onClick={()=> changeSelectedGuide('delivery')} style={{
                    width:"130px",
                    border: deliveryGuide ? "solid 2px darkorange" : null,
                    cursor:"pointer",
                    padding:"15px",
                    borderRadius:"10px"
                }}>
                    <div className="user-center" style={{height:"90px"}}>
                        <div className="user-center" style={{width:"80px", height:"70px", backgroundColor:"var(--up-panel)", borderRadius:"10px"}}>
                            <img style={{width:"40px", height:"40px", opacity:"0.7"}} src={detailDelivery} alt="delivery"/>
                        </div>
                    </div>
                    <div className="user-center font-t-cont">
                        <p className="text-center font-s-15">{t('ugCont12')}</p>
                    </div>
                </div>
            </div>
            { cartGuide ?
                // 장바구니가이드 내용
                <div>
                    <div className="user-center ht-100 m-t-50 ug-proc-head" style={{borderBottom: "solid 1px var(--up-border)"}}>
                        <div className="user-center">
                            <p className="font-s-25 font-t-title">{t('ugCont13')}</p>
                            <img onClick={openCartGuidePopup} className="wd-30 ht-30 m-l-10 c-point m-b-5" src={commonGuide} alt="guide"/>
                            <p className="font-t-cont font-s-13 m-l-3">({t('ugCont14')})</p>
                        </div>
                    </div>
                    <div className="font-t-cont ug-proc-row" style={{height:"150px", display:"flex", alignItems:"center", justifyContent:"center", marginTop:"40px"}}>
                        {/*절차1*/}
                        <div>
                            <div style={{width:"150px", minHeight:"150px"}}>
                                <div className="user-center" style={{height:"90px", position:"relative"}}>
                                    <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideOne} alt="one"/>
                                    <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc1} alt="process1"/>
                                </div>
                                <div className="user-center">
                                    <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont15')}</p>
                                </div>
                            </div>
                        </div>
                        {/*절차2*/}
                        <div>
                            <div style={{width:"150px", minHeight:"150px"}}>
                                <div className="user-center" style={{height:"90px", position:"relative"}}>
                                    <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideTwo} alt="two"/>
                                    <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc2} alt="process2"/>
                                </div>
                                <div className="user-center">
                                    <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont16')}</p>
                                </div>
                            </div>
                        </div>
                        {/*절차3*/}
                        <div>
                            <div style={{width:"150px", minHeight:"150px"}}>
                                <div className="user-center" style={{height:"90px", position:"relative"}}>
                                    <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideThree} alt="three"/>
                                    <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc4} alt="process3"/>
                                </div>
                                <div className="user-center">
                                    <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont17')}</p>
                                </div>
                            </div>
                        </div>
                        {/*절차4*/}
                        <div>
                            <div style={{width:"150px", minHeight:"150px"}}>
                                <div className="user-center" style={{height:"90px", position:"relative"}}>
                                    <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideFour} alt="four"/>
                                    <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc3} alt="process4"/>
                                </div>
                                <div className="user-center">
                                    <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont18')}</p>
                                </div>
                            </div>
                        </div>
                        {/*절차5*/}
                        <div>
                            <div style={{width:"150px", minHeight:"150px"}}>
                                <div className="user-center" style={{height:"90px", position:"relative"}}>
                                    <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideFive} alt="five"/>
                                    <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc5} alt="process5"/>
                                </div>
                                <div className="user-center">
                                    <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont19')}</p>
                                </div>
                            </div>
                        </div>
                        {/*절차6*/}
                        <div>
                            <div style={{width:"150px", minHeight:"150px"}}>
                                <div className="user-center" style={{height:"90px", position:"relative"}}>
                                    <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "lightgrayscale(100%) brightness(99%)"}}  src={guideSix} alt="six"/>
                                    <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc6} alt="process6"/>
                                </div>
                                <div className="user-center">
                                    <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont20')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*장바구니 사진영역 (신규 UI 목업 + SVG 가이드)*/}
                    <div className="cg-wrap">

                        {/* ===== Step 1 : 장바구니 담기 ===== */}
                        <div className="cg-card">
                            <div className="cg-step-head">
                                <div className="cg-badge">1</div>
                                <p className="cg-title">{t('cgS1Title')}</p>
                            </div>
                            <p className="cg-desc">{t('cgS1Desc')}</p>
                            <div style={{marginTop: "18px"}}>
                                <svg className="cg-svg" viewBox="0 0 560 380" role="img" aria-label="shopping cart">
                                    <rect x="8" y="8" width="544" height="364" rx="16" fill="var(--up-surface-2)" stroke="var(--up-border)" strokeWidth="1.5"/>
                                    {/* header */}
                                    <path d="M28 32 h5 l2.6 13 h15 l3 -9 h-17" fill="none" stroke="var(--up-brand-2)" strokeWidth="2.2" strokeLinejoin="round" strokeLinecap="round"/>
                                    <circle cx="39" cy="50" r="2.6" fill="var(--up-brand-2)"/>
                                    <circle cx="50" cy="50" r="2.6" fill="var(--up-brand-2)"/>
                                    <text x="66" y="47" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="15" fill="var(--up-text)">SHOPPING CART</text>
                                    <line x1="28" y1="66" x2="524" y2="66" stroke="var(--up-border)" strokeWidth="1"/>
                                    {/* item rows */}
                                    <g>
                                        <rect x="28" y="80" width="46" height="46" rx="9" fill="var(--up-brand-soft)" stroke="var(--up-border)" strokeWidth="1"/>
                                        <text x="88" y="99" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="14" fill="var(--up-text)">Oversized Hoodie</text>
                                        <text x="88" y="118" fontSize="12" fill="var(--up-text-sub)">Black / L</text>
                                        <text x="524" y="110" textAnchor="end" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="14" fill="var(--up-text)">&#8361; 59,000</text>
                                    </g>
                                    <g>
                                        <rect x="28" y="138" width="46" height="46" rx="9" fill="var(--up-brand-soft)" stroke="var(--up-border)" strokeWidth="1"/>
                                        <text x="88" y="157" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="14" fill="var(--up-text)">Canvas Sneakers</text>
                                        <text x="88" y="176" fontSize="12" fill="var(--up-text-sub)">White / 270</text>
                                        <text x="524" y="168" textAnchor="end" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="14" fill="var(--up-text)">&#8361; 89,000</text>
                                    </g>
                                    <g>
                                        <rect x="28" y="196" width="46" height="46" rx="9" fill="var(--up-brand-soft)" stroke="var(--up-border)" strokeWidth="1"/>
                                        <text x="88" y="215" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="14" fill="var(--up-text)">Logo Ball Cap</text>
                                        <text x="88" y="234" fontSize="12" fill="var(--up-text-sub)">Beige / Free</text>
                                        <text x="524" y="226" textAnchor="end" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="14" fill="var(--up-text)">&#8361; 30,000</text>
                                    </g>
                                    <line x1="28" y1="262" x2="524" y2="262" stroke="var(--up-border)" strokeWidth="1"/>
                                    {/* totals */}
                                    <text x="28" y="292" fontSize="13" fill="var(--up-text-sub)">{t('cgUiTotalQty')}</text>
                                    <text x="120" y="292" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="13" fill="var(--up-text)">3</text>
                                    <text x="380" y="292" fontSize="13" fill="var(--up-text-sub)">{t('cgUiTotalAmt')}</text>
                                    <text x="524" y="292" textAnchor="end" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="16" fill="var(--up-brand-2)">&#8361; 178,000</text>
                                    {/* order button */}
                                    <rect x="28" y="310" width="496" height="46" rx="11" fill="var(--up-brand)"/>
                                    <text x="276" y="339" textAnchor="middle" fontFamily="'LINESeedKR-Bd', sans-serif" fontSize="15" fill="#ffffff">{t('cgUiOrderBtn')}</text>
                                </svg>
                            </div>
                        </div>

                        {/* ===== Step 2 : 장바구니 신청 ===== */}
                        <div className="cg-card">
                            <div className="cg-step-head">
                                <div className="cg-badge">2</div>
                                <p className="cg-title">{t('cgS2Title')}</p>
                            </div>
                            <p className="cg-desc">{t('cgS2Desc')}</p>

                            <div className="cg-sub-grid">
                                {/* 2-1 헤더 [장바구니] */}
                                <div className="cg-sub">
                                    <span className="cg-sub-tag">STEP 2-1</span>
                                    <p className="cg-sub-cap">{t('cgS2aCap')}</p>
                                    <div className="cg-mock">
                                        <div className="cg-hd">
                                            <span className="cg-hd-logo">Btorage</span>
                                            <div className="cg-hd-nav">
                                                <span className="cg-nav-item">{t('hdMenu1')}</span>
                                                <span className="cg-nav-item cg-nav-hot cg-pulse">{t('hdMenu2')}</span>
                                                <span className="cg-nav-item">{t('hdMenu3')}</span>
                                                <span className="cg-nav-item">{t('hdMenu4')}</span>
                                                <span className="cg-nav-item">{t('hdMenu5')}</span>
                                            </div>
                                            <span className="cg-nav-item cg-nav-ghost">{t('hdMypg')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="cg-arrow">&#8595;</div>

                                {/* 2-2 장바구니 서비스폼 */}
                                <div className="cg-sub">
                                    <span className="cg-sub-tag">STEP 2-2</span>
                                    <p className="cg-sub-cap">{t('cgS2bCap')}</p>
                                    <div className="cg-mock">
                                        <div className="cg-mock-bar">
                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiCartFormTitle')}</span>
                                        </div>
                                        <div className="cg-mock-body">
                                            <div className="cg-form">
                                                <div className="cg-field">
                                                    <span className="cg-label">{t('cgUiShopId')}</span>
                                                    <span className="cg-input">mall_account01</span>
                                                </div>
                                                <div className="cg-field">
                                                    <span className="cg-label">{t('cgUiShopPw')}</span>
                                                    <span className="cg-input">••••••••</span>
                                                </div>
                                                <div className="cg-field">
                                                    <span className="cg-label">{t('cgUiCartQty')}</span>
                                                    <span className="cg-input">3</span>
                                                </div>
                                                <div className="cg-field">
                                                    <span className="cg-label">{t('cgUiCartAmt')}</span>
                                                    <span className="cg-input">&#8361; 178,000</span>
                                                </div>
                                                <div className="cg-field full">
                                                    <span className="cg-label">{t('cgUiProdUrl')}</span>
                                                    <span className="cg-input ph">https://shop.example.com/cart</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('cgS2bNote')}</span></div>
                                </div>
                                <div className="cg-arrow">&#8595;</div>

                                {/* 2-3 요청사항 */}
                                <div className="cg-sub">
                                    <span className="cg-sub-tag">STEP 2-3</span>
                                    <p className="cg-sub-cap">{t('cgS2cCap')}</p>
                                    <div className="cg-mock">
                                        <div className="cg-mock-bar">
                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiReqTitle')}</span>
                                        </div>
                                        <div className="cg-mock-body">
                                            <div className="cg-check-list">
                                                <div className="cg-check on"><span className="cg-check-box">&#10003;</span>{t('cgUiReqShoe')}</div>
                                                <div className="cg-check on"><span className="cg-check-box">&#10003;</span>{t('cgUiReqHanger')}</div>
                                                <div className="cg-check"><span className="cg-check-box"/>{t('cgUiReqHold')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="cg-arrow">&#8595;</div>

                                {/* 2-4 결제정보 */}
                                <div className="cg-sub">
                                    <span className="cg-sub-tag">STEP 2-4</span>
                                    <p className="cg-sub-cap">{t('cgS2dCap')}</p>
                                    <div className="cg-mock">
                                        <div className="cg-mock-bar">
                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayTitle')}</span>
                                        </div>
                                        <div className="cg-mock-body">
                                            <div className="cg-pay-grid">
                                                <div className="cg-pay-tile sel"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Global)</div>
                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Korean)</div>
                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>GlobalCard</div>
                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>KoreanPay</div>
                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#80;</div>Paypal</div>
                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#8361;</div>{t('cgUiDeposit')}</div>
                                            </div>
                                            <div className="cg-btn-row">
                                                <div className="cg-btn cg-btn-pay cg-pulse">Pay</div>
                                                <div className="cg-btn cg-btn-save">Save</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('cgS2Note')}</span></div>
                        </div>

                        {/* ===== Step 3 : 해외배송비 청구 ===== */}
                        <div className="cg-card">
                            <div className="cg-step-head">
                                <div className="cg-badge">3</div>
                                <p className="cg-title">{t('cgS3Title')}</p>
                            </div>
                            <p className="cg-desc">{t('cgS3Desc')}</p>

                            <div className="cg-sub-grid">
                                {/* 3-1 [MyPg] */}
                                <div className="cg-sub">
                                    <span className="cg-sub-tag">STEP 3-1</span>
                                    <p className="cg-sub-cap">{t('cgS3aCap')}</p>
                                    <div className="cg-mock">
                                        <div className="cg-hd">
                                            <span className="cg-hd-logo">Btorage</span>
                                            <div className="cg-hd-nav">
                                                <span className="cg-nav-item">{t('hdMenu1')}</span>
                                                <span className="cg-nav-item">{t('hdMenu2')}</span>
                                                <span className="cg-nav-item">{t('hdMenu3')}</span>
                                                <span className="cg-nav-item">{t('hdMenu4')}</span>
                                            </div>
                                            <span className="cg-nav-item cg-nav-hot cg-pulse">{t('hdMypg')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="cg-arrow">&#8595;</div>

                                {/* 3-2 배송사별 해외배송료 목록 [상세] */}
                                <div className="cg-sub">
                                    <span className="cg-sub-tag">STEP 3-2</span>
                                    <p className="cg-sub-cap">{t('cgS3bCap')}</p>
                                    <div className="cg-mock">
                                        <div className="cg-mock-bar">
                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiShipFeeTitle')}</span>
                                        </div>
                                        <div className="cg-mock-body">
                                            <div className="cg-list">
                                                <div className="cg-row-sb" style={{padding: "11px 13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                    <span style={{fontSize: "13px", color: "var(--up-text)"}}>BT2507-0001 · Box A</span>
                                                    <span className="cg-detail-btn cg-pulse">{t('cgUiDetail')}</span>
                                                </div>
                                                <div className="cg-row-sb" style={{padding: "11px 13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                    <span style={{fontSize: "13px", color: "var(--up-text)"}}>BT2507-0001 · Box B</span>
                                                    <span className="cg-detail-btn cg-pulse">{t('cgUiDetail')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="cg-arrow">&#8595;</div>

                                {/* 3-3 수취인정보 / 세관신고&보험 */}
                                <div className="cg-sub">
                                    <span className="cg-sub-tag">STEP 3-3</span>
                                    <p className="cg-sub-cap">{t('cgS3cCap')}</p>
                                    <div className="cg-mock">
                                        <div className="cg-mock-bar">
                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiReceiver')} · {t('cgUiCustoms')}</span>
                                        </div>
                                        <div className="cg-mock-body">
                                            <div className="cg-form">
                                                <div className="cg-field">
                                                    <span className="cg-label">{t('cgUiRecName')}</span>
                                                    <span className="cg-input">John Doe</span>
                                                </div>
                                                <div className="cg-field">
                                                    <span className="cg-label">{t('cgUiRecTel')}</span>
                                                    <span className="cg-input">+1 202-555-0147</span>
                                                </div>
                                                <div className="cg-field full">
                                                    <span className="cg-label">{t('cgUiRecAddr')}</span>
                                                    <span className="cg-input ph">1600 Pennsylvania Ave NW, Washington</span>
                                                </div>
                                                <div className="cg-field">
                                                    <span className="cg-label">{t('cgUiDeclare')}</span>
                                                    <span className="cg-input">USD 120</span>
                                                </div>
                                                <div className="cg-field">
                                                    <span className="cg-label">{t('cgUiInsurance')}</span>
                                                    <span className="cg-input">ON</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('cgS3Note')}</span></div>
                        </div>

                        {/* ===== Step 4 : 해외배송비 결제 ===== */}
                        <div className="cg-card">
                            <div className="cg-step-head">
                                <div className="cg-badge">4</div>
                                <p className="cg-title">{t('cgS4Title')}</p>
                            </div>
                            <p className="cg-desc">{t('cgS4Desc')}</p>

                            <div className="cg-sub-grid">
                                {/* 4-1 결제목록 배송사 비교견적 */}
                                <div className="cg-sub">
                                    <span className="cg-sub-tag">STEP 4-1</span>
                                    <p className="cg-sub-cap">{t('cgS4aCap')}</p>
                                    <div className="cg-mock">
                                        <div className="cg-mock-bar">
                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayListTitle')}</span>
                                        </div>
                                        <div className="cg-mock-body">
                                            <div className="cg-list">
                                                <div className="cg-carrier sel">
                                                    <span className="cg-carrier-logo">FedEx</span>
                                                    <span className="cg-carrier-price">&#8361; 62,400</span>
                                                    <span className="cg-carrier-meta"><span>{t('cgUiTime')} 3-5d</span><span>{t('cgUiOut')} 128</span></span>
                                                </div>
                                                <div className="cg-carrier">
                                                    <span className="cg-carrier-logo">FedEx-E</span>
                                                    <span className="cg-carrier-price">&#8361; 54,900</span>
                                                    <span className="cg-carrier-meta"><span>{t('cgUiTime')} 5-8d</span><span>{t('cgUiOut')} 96</span></span>
                                                </div>
                                                <div className="cg-carrier">
                                                    <span className="cg-carrier-logo">UPS</span>
                                                    <span className="cg-carrier-price">&#8361; 60,100</span>
                                                    <span className="cg-carrier-meta"><span>{t('cgUiTime')} 3-5d</span><span>{t('cgUiOut')} 74</span></span>
                                                </div>
                                                <div className="cg-carrier">
                                                    <span className="cg-carrier-logo">EMS</span>
                                                    <span className="cg-carrier-price">&#8361; 48,300</span>
                                                    <span className="cg-carrier-meta"><span>{t('cgUiTime')} 7-12d</span><span>{t('cgUiOut')} 210</span></span>
                                                </div>
                                                <div className="cg-carrier">
                                                    <span className="cg-carrier-logo">K-Packet</span>
                                                    <span className="cg-carrier-price">&#8361; 33,700</span>
                                                    <span className="cg-carrier-meta"><span>{t('cgUiTime')} 10-16d</span><span>{t('cgUiOut')} 305</span></span>
                                                </div>
                                                <div className="cg-carrier">
                                                    <span className="cg-carrier-logo">Sea</span>
                                                    <span className="cg-carrier-price">&#8361; 21,900</span>
                                                    <span className="cg-carrier-meta"><span>{t('cgUiTime')} 30-45d</span><span>{t('cgUiOut')} 58</span></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="cg-arrow">&#8595;</div>

                                {/* 4-2 결제수단 선택 후 Pay */}
                                <div className="cg-sub">
                                    <span className="cg-sub-tag">STEP 4-2</span>
                                    <p className="cg-sub-cap">{t('cgS4bCap')}</p>
                                    <div className="cg-mock">
                                        <div className="cg-mock-bar">
                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayTitle')}</span>
                                        </div>
                                        <div className="cg-mock-body">
                                            <div className="cg-pay-grid">
                                                <div className="cg-pay-tile sel"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Global)</div>
                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>GlobalCard</div>
                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#80;</div>Paypal</div>
                                            </div>
                                            <div className="cg-btn-row">
                                                <div className="cg-btn cg-btn-pay cg-pulse">Pay</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('cgS4Note')}</span></div>
                        </div>

                        {/* ===== Step 5 : 해외로 출발 ===== */}
                        <div className="cg-card">
                            <div className="cg-step-head">
                                <div className="cg-badge">5</div>
                                <p className="cg-title">{t('cgS5Title')}</p>
                            </div>
                            <p className="cg-desc">{t('cgS5Desc')}</p>

                            <div className="cg-sub-grid">
                                <div className="cg-sub">
                                    <span className="cg-sub-tag">STEP 5-1</span>
                                    <p className="cg-sub-cap">{t('cgS5aCap')}</p>
                                    <div className="cg-mock">
                                        <div className="cg-mock-bar">
                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiShipListTitle')}</span>
                                        </div>
                                        <div className="cg-mock-body">
                                            <div className="cg-list">
                                                <div style={{padding: "13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                    <div className="cg-row-sb">
                                                        <span style={{fontSize: "13px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>Box A · FedEx</span>
                                                        <span className="cg-chip done">{t('cgUiShipDone')}</span>
                                                    </div>
                                                    <div className="cg-row-sb" style={{marginTop: "9px"}}>
                                                        <span style={{fontSize: "12px", color: "var(--up-text-sub)"}}>{t('cgUiTrackNo')}</span>
                                                        <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-brand-2)"}}>7749 1023 8865</span>
                                                    </div>
                                                </div>
                                                <div style={{padding: "13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                    <div className="cg-row-sb">
                                                        <span style={{fontSize: "13px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>Box B · EMS</span>
                                                        <span className="cg-chip done">{t('cgUiShipDone')}</span>
                                                    </div>
                                                    <div className="cg-row-sb" style={{marginTop: "9px"}}>
                                                        <span style={{fontSize: "12px", color: "var(--up-text-sub)"}}>{t('cgUiTrackNo')}</span>
                                                        <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-brand-2)"}}>EE 0345 1180 KR</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('cgS5Note')}</span></div>
                        </div>

                        {/* ===== Step 6 : 상품수령 ===== */}
                        <div className="cg-card">
                            <div className="cg-step-head">
                                <div className="cg-badge">6</div>
                                <p className="cg-title">{t('cgS6Title')}</p>
                            </div>
                            <p className="cg-desc">{t('cgS6Desc')}</p>
                            <div style={{marginTop: "18px"}}>
                                <RcvScene t={t}/>
                            </div>
                        </div>

                    </div>
                </div>
                :
                orderGuide ?
                    // 구매대행가이드 내용
                    <div>
                        <div className="user-center ht-100 m-t-50 ug-proc-head" style={{borderBottom: "solid 1px var(--up-border)"}}>
                            <div className="user-center">
                                <p className="font-s-25 font-t-title">{t('ugCont21')}</p>
                                <img onClick={openOrderGuidePopup} className="wd-30 ht-30 m-l-10 c-point m-b-5" src={commonGuide} alt="guide"/>
                                <p className="font-t-cont font-s-13 m-l-3">({t('ugCont14')})</p>
                            </div>
                        </div>
                        <div className="font-t-cont ug-proc-row" style={{height:"150px", display:"flex", alignItems:"center", justifyContent:"center", marginTop:"40px"}}>
                            {/*절차1*/}
                            <div>
                                <div style={{width:"150px", minHeight:"150px"}}>
                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideOne} alt="one"/>
                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc2} alt="process2"/>
                                    </div>
                                    <div className="user-center">
                                        <p style={{fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont22')}</p>
                                    </div>
                                </div>
                            </div>
                            {/*절차2*/}
                            <div>
                                <div style={{width:"150px", minHeight:"150px"}}>
                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideTwo} alt="two"/>
                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc3} alt="process2"/>
                                    </div>
                                    <div className="user-center">
                                        <p style={{fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont23')}</p>
                                    </div>
                                </div>
                            </div>
                            {/*절차3*/}
                            <div>
                                <div style={{width:"150px", minHeight:"150px"}}>
                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideThree} alt="three"/>
                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc4} alt="process3"/>
                                    </div>
                                    <div className="user-center">
                                        <p style={{fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont17')}</p>
                                    </div>
                                </div>
                            </div>
                            {/*절차4*/}
                            <div>
                                <div style={{width:"150px", minHeight:"150px"}}>
                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideFour} alt="four"/>
                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc3} alt="process4"/>
                                    </div>
                                    <div className="user-center">
                                        <p style={{fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont18')}</p>
                                    </div>
                                </div>
                            </div>
                            {/*절차5*/}
                            <div>
                                <div style={{width:"150px", minHeight:"150px"}}>
                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideFive} alt="five"/>
                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc5} alt="process5"/>
                                    </div>
                                    <div className="user-center">
                                        <p style={{fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont19')}</p>
                                    </div>
                                </div>
                            </div>
                            {/*절차6*/}
                            <div>
                                <div style={{width:"150px", minHeight:"150px"}}>
                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideSix} alt="six"/>
                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc6} alt="process6"/>
                                    </div>
                                    <div className="user-center">
                                        <p style={{fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont20')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*구매대행 가이드영역 (신규 UI 목업 + SVG 가이드)*/}
                        <div className="cg-wrap">

                            {/* ===== Step 1 : 구매대행신청 ===== */}
                            <div className="cg-card">
                                <div className="cg-step-head">
                                    <div className="cg-badge">1</div>
                                    <p className="cg-title">{t('ogS1Title')}</p>
                                </div>
                                <p className="cg-desc">{t('ogS1Desc')}</p>

                                <div className="cg-sub-grid">
                                    {/* 1-1 헤더 [구매대행] → [구매대행신청] */}
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 1-1</span>
                                        <p className="cg-sub-cap">{t('ogS1aCap')}</p>
                                        <div className="cg-mock">
                                            <div className="cg-hd">
                                                <span className="cg-hd-logo">Btorage</span>
                                                <div className="cg-hd-nav">
                                                    <span className="cg-nav-item">{t('hdMenu1')}</span>
                                                    <span className="cg-nav-item">{t('hdMenu2')}</span>
                                                    <span className="cg-nav-item cg-nav-hot cg-pulse">{t('hdMenu3')}</span>
                                                    <span className="cg-nav-item">{t('hdMenu4')}</span>
                                                    <span className="cg-nav-item">{t('hdMenu5')}</span>
                                                </div>
                                                <span className="cg-nav-item cg-nav-ghost">{t('hdMypg')}</span>
                                            </div>
                                            <div style={{padding: "0 14px 14px"}}>
                                                <div style={{display: "inline-flex", flexDirection: "column", gap: "6px", padding: "8px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                    <span className="cg-detail-btn cg-pulse">{t('hdSMenu6')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cg-arrow">&#8595;</div>

                                    {/* 1-2 구매대행 서비스폼 */}
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 1-2</span>
                                        <p className="cg-sub-cap">{t('ogS1bCap')}</p>
                                        <div className="cg-mock">
                                            <div className="cg-mock-bar">
                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('ogUiOrderFormTitle')}</span>
                                            </div>
                                            <div className="cg-mock-body">
                                                <div className="cg-form">
                                                    <div className="cg-field full">
                                                        <span className="cg-label">{t('ogUiProdName')}</span>
                                                        <span className="cg-input">Oversized Hoodie</span>
                                                    </div>
                                                    <div className="cg-field">
                                                        <span className="cg-label">{t('ogUiOption')}</span>
                                                        <span className="cg-input">Black / L</span>
                                                    </div>
                                                    <div className="cg-field">
                                                        <span className="cg-label">{t('ogUiQty')}</span>
                                                        <span className="cg-input">1</span>
                                                    </div>
                                                    <div className="cg-field">
                                                        <span className="cg-label">{t('ogUiPrice')}</span>
                                                        <span className="cg-input">&#8361; 59,000</span>
                                                    </div>
                                                    <div className="cg-field">
                                                        <span className="cg-label">{t('ogUiShopFee')}</span>
                                                        <span className="cg-input">&#8361; 3,000</span>
                                                    </div>
                                                    <div className="cg-field full">
                                                        <span className="cg-label">{t('cgUiProdUrl')}</span>
                                                        <span className="cg-input ph">https://shop.example.com/product/123</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('ogS1bNote')}</span></div>
                                    </div>
                                </div>

                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('ogS1Note')}</span></div>
                            </div>

                            {/* ===== Step 2 : 상품금액결제 ===== */}
                            <div className="cg-card">
                                <div className="cg-step-head">
                                    <div className="cg-badge">2</div>
                                    <p className="cg-title">{t('ogS2Title')}</p>
                                </div>
                                <p className="cg-desc">{t('ogS2Desc')}</p>

                                <div className="cg-sub-grid">
                                    {/* 2-1 요청사항 */}
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 2-1</span>
                                        <p className="cg-sub-cap">{t('ogS2aCap')}</p>
                                        <div className="cg-mock">
                                            <div className="cg-mock-bar">
                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiReqTitle')}</span>
                                            </div>
                                            <div className="cg-mock-body">
                                                <div className="cg-check-list">
                                                    <div className="cg-check on"><span className="cg-check-box">&#10003;</span>{t('cgUiReqShoe')}</div>
                                                    <div className="cg-check on"><span className="cg-check-box">&#10003;</span>{t('cgUiReqHanger')}</div>
                                                    <div className="cg-check"><span className="cg-check-box"/>{t('cgUiReqHold')}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cg-arrow">&#8595;</div>

                                    {/* 2-2 결제정보 */}
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 2-2</span>
                                        <p className="cg-sub-cap">{t('ogS2bCap')}</p>
                                        <div className="cg-mock">
                                            <div className="cg-mock-bar">
                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayTitle')}</span>
                                            </div>
                                            <div className="cg-mock-body">
                                                <div className="cg-pay-grid">
                                                    <div className="cg-pay-tile sel"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Global)</div>
                                                    <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Korean)</div>
                                                    <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>GlobalCard</div>
                                                    <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>KoreanPay</div>
                                                    <div className="cg-pay-tile"><div className="cg-pay-ico">&#80;</div>Paypal</div>
                                                    <div className="cg-pay-tile"><div className="cg-pay-ico">&#8361;</div>{t('cgUiDeposit')}</div>
                                                </div>
                                                <div className="cg-btn-row">
                                                    <div className="cg-btn cg-btn-pay cg-pulse">Pay</div>
                                                    <div className="cg-btn cg-btn-save">Save</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cg-arrow">&#8595;</div>

                                    {/* 2-3 Btorage 구매대행 주문 (SVG) */}
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 2-3</span>
                                        <p className="cg-sub-cap">{t('ogS2cCap')}</p>
                                        <div style={{marginTop: "4px"}}>
                                            <ShopAgentScene t={t}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('ogS2Note')}</span></div>
                            </div>

                            {/* ===== Step 3 : 해외배송비 청구 ===== */}
                            <div className="cg-card">
                                <div className="cg-step-head">
                                    <div className="cg-badge">3</div>
                                    <p className="cg-title">{t('ogS3Title')}</p>
                                </div>
                                <p className="cg-desc">{t('ogS3Desc')}</p>

                                <div className="cg-sub-grid">
                                    {/* 3-1 [MyPg] */}
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 3-1</span>
                                        <p className="cg-sub-cap">{t('ogS3aCap')}</p>
                                        <div className="cg-mock">
                                            <div className="cg-hd">
                                                <span className="cg-hd-logo">Btorage</span>
                                                <div className="cg-hd-nav">
                                                    <span className="cg-nav-item">{t('hdMenu1')}</span>
                                                    <span className="cg-nav-item">{t('hdMenu2')}</span>
                                                    <span className="cg-nav-item">{t('hdMenu3')}</span>
                                                    <span className="cg-nav-item">{t('hdMenu4')}</span>
                                                </div>
                                                <span className="cg-nav-item cg-nav-hot cg-pulse">{t('hdMypg')}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cg-arrow">&#8595;</div>

                                    {/* 3-2 배송사별 해외배송료 목록 [상세] */}
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 3-2</span>
                                        <p className="cg-sub-cap">{t('ogS3bCap')}</p>
                                        <div className="cg-mock">
                                            <div className="cg-mock-bar">
                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiShipFeeTitle')}</span>
                                            </div>
                                            <div className="cg-mock-body">
                                                <div className="cg-list">
                                                    <div className="cg-row-sb" style={{padding: "11px 13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                        <span style={{fontSize: "13px", color: "var(--up-text)"}}>BT2507-0042 · Box A</span>
                                                        <span className="cg-detail-btn cg-pulse">{t('cgUiDetail')}</span>
                                                    </div>
                                                    <div className="cg-row-sb" style={{padding: "11px 13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                        <span style={{fontSize: "13px", color: "var(--up-text)"}}>BT2507-0042 · Box B</span>
                                                        <span className="cg-detail-btn cg-pulse">{t('cgUiDetail')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cg-arrow">&#8595;</div>

                                    {/* 3-3 수취인정보 / 세관신고&보험 */}
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 3-3</span>
                                        <p className="cg-sub-cap">{t('ogS3cCap')}</p>
                                        <div className="cg-mock">
                                            <div className="cg-mock-bar">
                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiReceiver')} · {t('cgUiCustoms')}</span>
                                            </div>
                                            <div className="cg-mock-body">
                                                <div className="cg-form">
                                                    <div className="cg-field">
                                                        <span className="cg-label">{t('cgUiRecName')}</span>
                                                        <span className="cg-input">John Doe</span>
                                                    </div>
                                                    <div className="cg-field">
                                                        <span className="cg-label">{t('cgUiRecTel')}</span>
                                                        <span className="cg-input">+1 202-555-0147</span>
                                                    </div>
                                                    <div className="cg-field full">
                                                        <span className="cg-label">{t('cgUiRecAddr')}</span>
                                                        <span className="cg-input ph">1600 Pennsylvania Ave NW, Washington</span>
                                                    </div>
                                                    <div className="cg-field">
                                                        <span className="cg-label">{t('cgUiDeclare')}</span>
                                                        <span className="cg-input">USD 120</span>
                                                    </div>
                                                    <div className="cg-field">
                                                        <span className="cg-label">{t('cgUiInsurance')}</span>
                                                        <span className="cg-input">ON</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('ogS3Note')}</span></div>
                            </div>

                            {/* ===== Step 4 : 해외배송비 결제 ===== */}
                            <div className="cg-card">
                                <div className="cg-step-head">
                                    <div className="cg-badge">4</div>
                                    <p className="cg-title">{t('ogS4Title')}</p>
                                </div>
                                <p className="cg-desc">{t('ogS4Desc')}</p>

                                <div className="cg-sub-grid">
                                    {/* 4-1 결제목록 배송사 비교견적 */}
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 4-1</span>
                                        <p className="cg-sub-cap">{t('ogS4aCap')}</p>
                                        <div className="cg-mock">
                                            <div className="cg-mock-bar">
                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayListTitle')}</span>
                                            </div>
                                            <div className="cg-mock-body">
                                                <div className="cg-list">
                                                    <div className="cg-carrier sel">
                                                        <span className="cg-carrier-logo">FedEx</span>
                                                        <span className="cg-carrier-price">&#8361; 62,400</span>
                                                        <span className="cg-carrier-meta"><span>{t('cgUiTime')} 3-5d</span><span>{t('cgUiOut')} 128</span></span>
                                                    </div>
                                                    <div className="cg-carrier">
                                                        <span className="cg-carrier-logo">UPS</span>
                                                        <span className="cg-carrier-price">&#8361; 60,100</span>
                                                        <span className="cg-carrier-meta"><span>{t('cgUiTime')} 3-5d</span><span>{t('cgUiOut')} 74</span></span>
                                                    </div>
                                                    <div className="cg-carrier">
                                                        <span className="cg-carrier-logo">EMS</span>
                                                        <span className="cg-carrier-price">&#8361; 48,300</span>
                                                        <span className="cg-carrier-meta"><span>{t('cgUiTime')} 7-12d</span><span>{t('cgUiOut')} 210</span></span>
                                                    </div>
                                                    <div className="cg-carrier">
                                                        <span className="cg-carrier-logo">K-Packet</span>
                                                        <span className="cg-carrier-price">&#8361; 33,700</span>
                                                        <span className="cg-carrier-meta"><span>{t('cgUiTime')} 10-16d</span><span>{t('cgUiOut')} 305</span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cg-arrow">&#8595;</div>

                                    {/* 4-2 결제수단 선택 후 Pay */}
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 4-2</span>
                                        <p className="cg-sub-cap">{t('ogS4bCap')}</p>
                                        <div className="cg-mock">
                                            <div className="cg-mock-bar">
                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayTitle')}</span>
                                            </div>
                                            <div className="cg-mock-body">
                                                <div className="cg-pay-grid">
                                                    <div className="cg-pay-tile sel"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Global)</div>
                                                    <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>GlobalCard</div>
                                                    <div className="cg-pay-tile"><div className="cg-pay-ico">&#80;</div>Paypal</div>
                                                </div>
                                                <div className="cg-btn-row">
                                                    <div className="cg-btn cg-btn-pay cg-pulse">Pay</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('ogS4Note')}</span></div>
                            </div>

                            {/* ===== Step 5 : 해외로 출발 ===== */}
                            <div className="cg-card">
                                <div className="cg-step-head">
                                    <div className="cg-badge">5</div>
                                    <p className="cg-title">{t('ogS5Title')}</p>
                                </div>
                                <p className="cg-desc">{t('ogS5Desc')}</p>

                                <div className="cg-sub-grid">
                                    <div className="cg-sub">
                                        <span className="cg-sub-tag">STEP 5-1</span>
                                        <p className="cg-sub-cap">{t('ogS5aCap')}</p>
                                        <div className="cg-mock">
                                            <div className="cg-mock-bar">
                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiShipListTitle')}</span>
                                            </div>
                                            <div className="cg-mock-body">
                                                <div className="cg-list">
                                                    <div style={{padding: "13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                        <div className="cg-row-sb">
                                                            <span style={{fontSize: "13px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>Box A · FedEx</span>
                                                            <span className="cg-chip done">{t('cgUiShipDone')}</span>
                                                        </div>
                                                        <div className="cg-row-sb" style={{marginTop: "9px"}}>
                                                            <span style={{fontSize: "12px", color: "var(--up-text-sub)"}}>{t('cgUiTrackNo')}</span>
                                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-brand-2)"}}>7749 1023 8865</span>
                                                        </div>
                                                    </div>
                                                    <div style={{padding: "13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                        <div className="cg-row-sb">
                                                            <span style={{fontSize: "13px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>Box B · EMS</span>
                                                            <span className="cg-chip done">{t('cgUiShipDone')}</span>
                                                        </div>
                                                        <div className="cg-row-sb" style={{marginTop: "9px"}}>
                                                            <span style={{fontSize: "12px", color: "var(--up-text-sub)"}}>{t('cgUiTrackNo')}</span>
                                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-brand-2)"}}>EE 0345 1180 KR</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('cgS5Note')}</span></div>
                            </div>

                            {/* ===== Step 6 : 상품수령 ===== */}
                            <div className="cg-card">
                                <div className="cg-step-head">
                                    <div className="cg-badge">6</div>
                                    <p className="cg-title">{t('cgS6Title')}</p>
                                </div>
                                <p className="cg-desc">{t('cgS6Desc')}</p>
                                <div style={{marginTop: "18px"}}>
                                    <RcvScene t={t}/>
                                </div>
                            </div>

                        </div>
                    </div>
                    :
                    offlineGuide ?
                        // 오프라인가이드 내용
                        <div>
                            <div className="user-center ht-100 m-t-50 ug-proc-head" style={{borderBottom: "solid 1px var(--up-border)"}}>
                                <div className="user-center">
                                    <p className="font-s-25 font-t-title">{t('ugCont24')}</p>
                                    <img onClick={openOfflineGuidePopup} className="wd-30 ht-30 m-l-10 c-point m-b-5" src={commonGuide} alt="guide"/>
                                    <p className="font-t-cont font-s-13 m-l-3">({t('ugCont14')})</p>
                                </div>
                            </div>
                            <div className="font-t-cont ug-proc-row" style={{height:"150px", display:"flex", alignItems:"center", justifyContent:"center", marginTop:"40px"}}>
                                {/*절차1*/}
                                <div>
                                    <div style={{width:"150px", minHeight:"150px"}}>
                                        <div className="user-center" style={{height:"90px", position:"relative"}}>
                                            <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideOne} alt="one"/>
                                            <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc2} alt="process1"/>
                                        </div>
                                        <div className="user-center">
                                            <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont25')}</p>
                                        </div>
                                    </div>
                                </div>
                                {/*절차2*/}
                                <div>
                                    <div style={{width:"150px", minHeight:"150px"}}>
                                        <div className="user-center" style={{height:"90px", position:"relative"}}>
                                            <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideTwo} alt="two"/>
                                            <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc3} alt="process2"/>
                                        </div>
                                        <div className="user-center">
                                            <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont23')}</p>
                                        </div>
                                    </div>
                                </div>
                                {/*절차3*/}
                                <div>
                                    <div style={{width:"150px", minHeight:"150px"}}>
                                        <div className="user-center" style={{height:"90px", position:"relative"}}>
                                            <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideThree} alt="three"/>
                                            <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc4} alt="process3"/>
                                        </div>
                                        <div className="user-center">
                                            <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont17')}</p>
                                        </div>
                                    </div>
                                </div>
                                {/*절차4*/}
                                <div>
                                    <div style={{width:"150px", minHeight:"150px"}}>
                                        <div className="user-center" style={{height:"90px", position:"relative"}}>
                                            <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideFour} alt="four"/>
                                            <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc3} alt="process4"/>
                                        </div>
                                        <div className="user-center">
                                            <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont18')}</p>
                                        </div>
                                    </div>
                                </div>
                                {/*절차5*/}
                                <div>
                                    <div style={{width:"150px", minHeight:"150px"}}>
                                        <div className="user-center" style={{height:"90px", position:"relative"}}>
                                            <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideFive} alt="five"/>
                                            <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc5} alt="process5"/>
                                        </div>
                                        <div className="user-center">
                                            <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont19')}</p>
                                        </div>
                                    </div>
                                </div>
                                {/*절차6*/}
                                <div>
                                    <div style={{width:"150px", minHeight:"150px"}}>
                                        <div className="user-center" style={{height:"90px", position:"relative"}}>
                                            <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideSix} alt="six"/>
                                            <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc6} alt="process6"/>
                                        </div>
                                        <div className="user-center">
                                            <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont20')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*오프라인 가이드영역 (신규 UI 목업 + SVG 가이드)*/}
                            <div className="cg-wrap">

                                {/* ===== Step 1 : 오프라인신청 ===== */}
                                <div className="cg-card">
                                    <div className="cg-step-head">
                                        <div className="cg-badge">1</div>
                                        <p className="cg-title">{t('offS1Title')}</p>
                                    </div>
                                    <p className="cg-desc">{t('offS1Desc')}</p>

                                    <div className="cg-sub-grid">
                                        {/* 1-1 헤더 [구매대행] → [오프라인신청] */}
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 1-1</span>
                                            <p className="cg-sub-cap">{t('offS1aCap')}</p>
                                            <div className="cg-mock">
                                                <div className="cg-hd">
                                                    <span className="cg-hd-logo">Btorage</span>
                                                    <div className="cg-hd-nav">
                                                        <span className="cg-nav-item">{t('hdMenu1')}</span>
                                                        <span className="cg-nav-item">{t('hdMenu2')}</span>
                                                        <span className="cg-nav-item cg-nav-hot cg-pulse">{t('hdMenu3')}</span>
                                                        <span className="cg-nav-item">{t('hdMenu4')}</span>
                                                        <span className="cg-nav-item">{t('hdMenu5')}</span>
                                                    </div>
                                                    <span className="cg-nav-item cg-nav-ghost">{t('hdMypg')}</span>
                                                </div>
                                                <div style={{padding: "0 14px 14px"}}>
                                                    <div style={{display: "inline-flex", flexDirection: "column", gap: "6px", padding: "8px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                        <span className="cg-detail-btn cg-pulse">{t('hdSMenu8')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cg-arrow">&#8595;</div>

                                        {/* 1-2 오프라인 서비스폼 */}
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 1-2</span>
                                            <p className="cg-sub-cap">{t('offS1bCap')}</p>
                                            <div className="cg-mock">
                                                <div className="cg-mock-bar">
                                                    <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                    <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('offUiOfflineFormTitle')}</span>
                                                </div>
                                                <div className="cg-mock-body">
                                                    <div className="cg-form">
                                                        <div className="cg-field full">
                                                            <span className="cg-label">{t('ogUiProdName')}</span>
                                                            <span className="cg-input">Local Store Sneakers</span>
                                                        </div>
                                                        <div className="cg-field">
                                                            <span className="cg-label">{t('ogUiQty')}</span>
                                                            <span className="cg-input">1</span>
                                                        </div>
                                                        <div className="cg-field">
                                                            <span className="cg-label">{t('ogUiPrice')}</span>
                                                            <span className="cg-input">&#8361; 129,000</span>
                                                        </div>
                                                        <div className="cg-field full">
                                                            <span className="cg-label">{t('offUiFee')}</span>
                                                            <span className="cg-input">&#8361; 15,000</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('offUiFeeNote')}</span></div>
                                            </div>
                                            <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('offS1bNote')}</span></div>
                                        </div>
                                    </div>

                                    <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('offS1Note')}</span></div>
                                </div>

                                {/* ===== Step 2 : 상품금액결제 ===== */}
                                <div className="cg-card">
                                    <div className="cg-step-head">
                                        <div className="cg-badge">2</div>
                                        <p className="cg-title">{t('offS2Title')}</p>
                                    </div>
                                    <p className="cg-desc">{t('offS2Desc')}</p>

                                    <div className="cg-sub-grid">
                                        {/* 2-1 요청사항 */}
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 2-1</span>
                                            <p className="cg-sub-cap">{t('offS2aCap')}</p>
                                            <div className="cg-mock">
                                                <div className="cg-mock-bar">
                                                    <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                    <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiReqTitle')}</span>
                                                </div>
                                                <div className="cg-mock-body">
                                                    <div className="cg-check-list">
                                                        <div className="cg-check on"><span className="cg-check-box">&#10003;</span>{t('offUiReqBigBox')}</div>
                                                        <div className="cg-check"><span className="cg-check-box"/>{t('cgUiReqHold')}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cg-arrow">&#8595;</div>

                                        {/* 2-2 결제정보 */}
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 2-2</span>
                                            <p className="cg-sub-cap">{t('offS2bCap')}</p>
                                            <div className="cg-mock">
                                                <div className="cg-mock-bar">
                                                    <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                    <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayTitle')}</span>
                                                </div>
                                                <div className="cg-mock-body">
                                                    <div className="cg-pay-grid">
                                                        <div className="cg-pay-tile sel"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Global)</div>
                                                        <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Korean)</div>
                                                        <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>GlobalCard</div>
                                                        <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>KoreanPay</div>
                                                        <div className="cg-pay-tile"><div className="cg-pay-ico">&#80;</div>Paypal</div>
                                                        <div className="cg-pay-tile"><div className="cg-pay-ico">&#8361;</div>{t('cgUiDeposit')}</div>
                                                    </div>
                                                    <div className="cg-btn-row">
                                                        <div className="cg-btn cg-btn-pay cg-pulse">Pay</div>
                                                        <div className="cg-btn cg-btn-save">Save</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cg-arrow">&#8595;</div>

                                        {/* 2-3 Btorage 오프라인 매장 방문 구매 (SVG) */}
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 2-3</span>
                                            <p className="cg-sub-cap">{t('offS2cCap')}</p>
                                            <div style={{marginTop: "4px"}}>
                                                <OfflineAgentScene t={t}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('offS2Note')}</span></div>
                                </div>

                                {/* ===== Step 3 : 해외배송비 청구 ===== */}
                                <div className="cg-card">
                                    <div className="cg-step-head">
                                        <div className="cg-badge">3</div>
                                        <p className="cg-title">{t('offS3Title')}</p>
                                    </div>
                                    <p className="cg-desc">{t('offS3Desc')}</p>

                                    <div className="cg-sub-grid">
                                        {/* 3-1 [MyPg] */}
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 3-1</span>
                                            <p className="cg-sub-cap">{t('offS3aCap')}</p>
                                            <div className="cg-mock">
                                                <div className="cg-hd">
                                                    <span className="cg-hd-logo">Btorage</span>
                                                    <div className="cg-hd-nav">
                                                        <span className="cg-nav-item">{t('hdMenu1')}</span>
                                                        <span className="cg-nav-item">{t('hdMenu2')}</span>
                                                        <span className="cg-nav-item">{t('hdMenu3')}</span>
                                                        <span className="cg-nav-item">{t('hdMenu4')}</span>
                                                    </div>
                                                    <span className="cg-nav-item cg-nav-hot cg-pulse">{t('hdMypg')}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cg-arrow">&#8595;</div>

                                        {/* 3-2 배송사별 해외배송료 목록 [상세] */}
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 3-2</span>
                                            <p className="cg-sub-cap">{t('offS3bCap')}</p>
                                            <div className="cg-mock">
                                                <div className="cg-mock-bar">
                                                    <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                    <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiShipFeeTitle')}</span>
                                                </div>
                                                <div className="cg-mock-body">
                                                    <div className="cg-list">
                                                        <div className="cg-row-sb" style={{padding: "11px 13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                            <span style={{fontSize: "13px", color: "var(--up-text)"}}>BT2507-0088 · Box A</span>
                                                            <span className="cg-detail-btn cg-pulse">{t('cgUiDetail')}</span>
                                                        </div>
                                                        <div className="cg-row-sb" style={{padding: "11px 13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                            <span style={{fontSize: "13px", color: "var(--up-text)"}}>BT2507-0088 · Box B</span>
                                                            <span className="cg-detail-btn cg-pulse">{t('cgUiDetail')}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cg-arrow">&#8595;</div>

                                        {/* 3-3 수취인정보 / 세관신고&보험 */}
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 3-3</span>
                                            <p className="cg-sub-cap">{t('offS3cCap')}</p>
                                            <div className="cg-mock">
                                                <div className="cg-mock-bar">
                                                    <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                    <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiReceiver')} · {t('cgUiCustoms')}</span>
                                                </div>
                                                <div className="cg-mock-body">
                                                    <div className="cg-form">
                                                        <div className="cg-field">
                                                            <span className="cg-label">{t('cgUiRecName')}</span>
                                                            <span className="cg-input">John Doe</span>
                                                        </div>
                                                        <div className="cg-field">
                                                            <span className="cg-label">{t('cgUiRecTel')}</span>
                                                            <span className="cg-input">+1 202-555-0147</span>
                                                        </div>
                                                        <div className="cg-field full">
                                                            <span className="cg-label">{t('cgUiRecAddr')}</span>
                                                            <span className="cg-input ph">1600 Pennsylvania Ave NW, Washington</span>
                                                        </div>
                                                        <div className="cg-field">
                                                            <span className="cg-label">{t('cgUiDeclare')}</span>
                                                            <span className="cg-input">USD 120</span>
                                                        </div>
                                                        <div className="cg-field">
                                                            <span className="cg-label">{t('cgUiInsurance')}</span>
                                                            <span className="cg-input">ON</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('offS3Note')}</span></div>
                                </div>

                                {/* ===== Step 4 : 해외배송비 결제 ===== */}
                                <div className="cg-card">
                                    <div className="cg-step-head">
                                        <div className="cg-badge">4</div>
                                        <p className="cg-title">{t('offS4Title')}</p>
                                    </div>
                                    <p className="cg-desc">{t('offS4Desc')}</p>

                                    <div className="cg-sub-grid">
                                        {/* 4-1 결제목록 배송사 비교견적 */}
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 4-1</span>
                                            <p className="cg-sub-cap">{t('offS4aCap')}</p>
                                            <div className="cg-mock">
                                                <div className="cg-mock-bar">
                                                    <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                    <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayListTitle')}</span>
                                                </div>
                                                <div className="cg-mock-body">
                                                    <div className="cg-list">
                                                        <div className="cg-carrier sel">
                                                            <span className="cg-carrier-logo">FedEx</span>
                                                            <span className="cg-carrier-price">&#8361; 62,400</span>
                                                            <span className="cg-carrier-meta"><span>{t('cgUiTime')} 3-5d</span><span>{t('cgUiOut')} 128</span></span>
                                                        </div>
                                                        <div className="cg-carrier">
                                                            <span className="cg-carrier-logo">UPS</span>
                                                            <span className="cg-carrier-price">&#8361; 60,100</span>
                                                            <span className="cg-carrier-meta"><span>{t('cgUiTime')} 3-5d</span><span>{t('cgUiOut')} 74</span></span>
                                                        </div>
                                                        <div className="cg-carrier">
                                                            <span className="cg-carrier-logo">EMS</span>
                                                            <span className="cg-carrier-price">&#8361; 48,300</span>
                                                            <span className="cg-carrier-meta"><span>{t('cgUiTime')} 7-12d</span><span>{t('cgUiOut')} 210</span></span>
                                                        </div>
                                                        <div className="cg-carrier">
                                                            <span className="cg-carrier-logo">K-Packet</span>
                                                            <span className="cg-carrier-price">&#8361; 33,700</span>
                                                            <span className="cg-carrier-meta"><span>{t('cgUiTime')} 10-16d</span><span>{t('cgUiOut')} 305</span></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cg-arrow">&#8595;</div>

                                        {/* 4-2 결제수단 선택 후 Pay */}
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 4-2</span>
                                            <p className="cg-sub-cap">{t('offS4bCap')}</p>
                                            <div className="cg-mock">
                                                <div className="cg-mock-bar">
                                                    <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                    <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayTitle')}</span>
                                                </div>
                                                <div className="cg-mock-body">
                                                    <div className="cg-pay-grid">
                                                        <div className="cg-pay-tile sel"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Global)</div>
                                                        <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>GlobalCard</div>
                                                        <div className="cg-pay-tile"><div className="cg-pay-ico">&#80;</div>Paypal</div>
                                                    </div>
                                                    <div className="cg-btn-row">
                                                        <div className="cg-btn cg-btn-pay cg-pulse">Pay</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('offS4Note')}</span></div>
                                </div>

                                {/* ===== Step 5 : 해외로 출발 ===== */}
                                <div className="cg-card">
                                    <div className="cg-step-head">
                                        <div className="cg-badge">5</div>
                                        <p className="cg-title">{t('offS5Title')}</p>
                                    </div>
                                    <p className="cg-desc">{t('offS5Desc')}</p>

                                    <div className="cg-sub-grid">
                                        <div className="cg-sub">
                                            <span className="cg-sub-tag">STEP 5-1</span>
                                            <p className="cg-sub-cap">{t('offS5aCap')}</p>
                                            <div className="cg-mock">
                                                <div className="cg-mock-bar">
                                                    <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                    <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiShipListTitle')}</span>
                                                </div>
                                                <div className="cg-mock-body">
                                                    <div className="cg-list">
                                                        <div style={{padding: "13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                            <div className="cg-row-sb">
                                                                <span style={{fontSize: "13px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>Box A · FedEx</span>
                                                                <span className="cg-chip done">{t('cgUiShipDone')}</span>
                                                            </div>
                                                            <div className="cg-row-sb" style={{marginTop: "9px"}}>
                                                                <span style={{fontSize: "12px", color: "var(--up-text-sub)"}}>{t('cgUiTrackNo')}</span>
                                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-brand-2)"}}>7749 1023 8865</span>
                                                            </div>
                                                        </div>
                                                        <div style={{padding: "13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                            <div className="cg-row-sb">
                                                                <span style={{fontSize: "13px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>Box B · EMS</span>
                                                                <span className="cg-chip done">{t('cgUiShipDone')}</span>
                                                            </div>
                                                            <div className="cg-row-sb" style={{marginTop: "9px"}}>
                                                                <span style={{fontSize: "12px", color: "var(--up-text-sub)"}}>{t('cgUiTrackNo')}</span>
                                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-brand-2)"}}>EE 0345 1180 KR</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('cgS5Note')}</span></div>
                                </div>

                                {/* ===== Step 6 : 상품수령 ===== */}
                                <div className="cg-card">
                                    <div className="cg-step-head">
                                        <div className="cg-badge">6</div>
                                        <p className="cg-title">{t('cgS6Title')}</p>
                                    </div>
                                    <p className="cg-desc">{t('cgS6Desc')}</p>
                                    <div style={{marginTop: "18px"}}>
                                        <RcvScene t={t}/>
                                    </div>
                                </div>

                            </div>
                        </div>
                        :
                        transferGuide ?
                            // 이체대행가이드 내용
                            <div>
                                <div className="user-center ht-100 m-t-50 ug-proc-head" style={{borderBottom: "solid 1px var(--up-border)"}}>
                                    <div className="user-center">
                                        <p className="font-s-25 font-t-title">{t('ugCont26')}</p>
                                        <img onClick={openTransferGuidePopup} className="wd-30 ht-30 m-l-10 c-point m-b-5" src={commonGuide} alt="guide"/>
                                        <p className="font-t-cont font-s-13 m-l-3">({t('ugCont14')})</p>
                                    </div>
                                </div>
                                <div className="font-t-cont ug-proc-row" style={{height:"150px", display:"flex", alignItems:"center", justifyContent:"center", marginTop:"40px"}}>
                                    {/*절차1*/}
                                    <div>
                                        <div style={{width:"150px", minHeight:"150px"}}>
                                            <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideOne} alt="one"/>
                                                <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc2} alt="process1"/>
                                            </div>
                                            <div className="user-center">
                                                <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont27')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/*절차2*/}
                                    <div>
                                        <div style={{width:"150px", minHeight:"150px"}}>
                                            <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideTwo} alt="two"/>
                                                <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc3} alt="process2"/>
                                            </div>
                                            <div className="user-center">
                                                <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont28')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/*절차3*/}
                                    <div>
                                        <div style={{width:"150px", minHeight:"150px"}}>
                                            <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideThree} alt="three"/>
                                                <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc5} alt="process3"/>
                                            </div>
                                            <div className="user-center">
                                                <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont29')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*이체대행 가이드영역 (신규 UI 목업 + SVG 가이드)*/}
                                <div className="cg-wrap">

                                    {/* ===== Step 1 : 이체대행신청 ===== */}
                                    <div className="cg-card">
                                        <div className="cg-step-head">
                                            <div className="cg-badge">1</div>
                                            <p className="cg-title">{t('trS1Title')}</p>
                                        </div>
                                        <p className="cg-desc">{t('trS1Desc')}</p>

                                        <div className="cg-sub-grid">
                                            {/* 1-1 헤더 [구매대행] → [이체대행신청] */}
                                            <div className="cg-sub">
                                                <span className="cg-sub-tag">STEP 1-1</span>
                                                <p className="cg-sub-cap">{t('trS1aCap')}</p>
                                                <div className="cg-mock">
                                                    <div className="cg-hd">
                                                        <span className="cg-hd-logo">Btorage</span>
                                                        <div className="cg-hd-nav">
                                                            <span className="cg-nav-item">{t('hdMenu1')}</span>
                                                            <span className="cg-nav-item">{t('hdMenu2')}</span>
                                                            <span className="cg-nav-item cg-nav-hot cg-pulse">{t('hdMenu3')}</span>
                                                            <span className="cg-nav-item">{t('hdMenu4')}</span>
                                                            <span className="cg-nav-item">{t('hdMenu5')}</span>
                                                        </div>
                                                        <span className="cg-nav-item cg-nav-ghost">{t('hdMypg')}</span>
                                                    </div>
                                                    <div style={{padding: "0 14px 14px"}}>
                                                        <div style={{display: "inline-flex", flexDirection: "column", gap: "6px", padding: "8px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                            <span className="cg-detail-btn cg-pulse">{t('hdSMenu7')}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="cg-arrow">&#8595;</div>

                                            {/* 1-2 이체대행 서비스폼 */}
                                            <div className="cg-sub">
                                                <span className="cg-sub-tag">STEP 1-2</span>
                                                <p className="cg-sub-cap">{t('trS1bCap')}</p>
                                                <div className="cg-mock">
                                                    <div className="cg-mock-bar">
                                                        <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                        <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('trUiTransferFormTitle')}</span>
                                                    </div>
                                                    <div className="cg-mock-body">
                                                        <div className="cg-form">
                                                            <div className="cg-field">
                                                                <span className="cg-label">{t('trUiBankName')}</span>
                                                                <span className="cg-input">KB Kookmin Bank</span>
                                                            </div>
                                                            <div className="cg-field">
                                                                <span className="cg-label">{t('trUiAccNo')}</span>
                                                                <span className="cg-input">123456-04-567890</span>
                                                            </div>
                                                            <div className="cg-field full">
                                                                <span className="cg-label">{t('trUiAccHolder')}</span>
                                                                <span className="cg-input">Hong Gil-dong</span>
                                                            </div>
                                                            <div className="cg-field">
                                                                <span className="cg-label">{t('trUiAmount')}</span>
                                                                <span className="cg-input">&#8361; 500,000</span>
                                                            </div>
                                                            <div className="cg-field">
                                                                <span className="cg-label">{t('trUiFee')}</span>
                                                                <span className="cg-input">&#8361; 35,000</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('trS1bNote')}</span></div>
                                            </div>
                                        </div>

                                        <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('trS1Note')}</span></div>
                                    </div>

                                    {/* ===== Step 2 : 이체금액결제 ===== */}
                                    <div className="cg-card">
                                        <div className="cg-step-head">
                                            <div className="cg-badge">2</div>
                                            <p className="cg-title">{t('trS2Title')}</p>
                                        </div>
                                        <p className="cg-desc">{t('trS2Desc')}</p>

                                        <div className="cg-sub-grid">
                                            <div className="cg-sub">
                                                <span className="cg-sub-tag">STEP 2-1</span>
                                                <p className="cg-sub-cap">{t('trS2aCap')}</p>
                                                <div className="cg-mock">
                                                    <div className="cg-mock-bar">
                                                        <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                        <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayTitle')}</span>
                                                    </div>
                                                    <div className="cg-mock-body">
                                                        <div className="cg-pay-grid">
                                                            <div className="cg-pay-tile sel"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Global)</div>
                                                            <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Korean)</div>
                                                            <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>GlobalCard</div>
                                                            <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>KoreanPay</div>
                                                            <div className="cg-pay-tile"><div className="cg-pay-ico">&#80;</div>Paypal</div>
                                                            <div className="cg-pay-tile"><div className="cg-pay-ico">&#8361;</div>{t('cgUiDeposit')}</div>
                                                        </div>
                                                        <div className="cg-btn-row">
                                                            <div className="cg-btn cg-btn-pay cg-pulse">Pay</div>
                                                            <div className="cg-btn cg-btn-save">Save</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('trS2Note')}</span></div>
                                    </div>

                                </div>
                            </div>
                            :
                            domesticGuide ?
                                // 국내배송가이드 내용
                                <div>
                                    <div className="user-center ht-100 m-t-50 ug-proc-head" style={{borderBottom: "solid 1px var(--up-border)"}}>
                                        <div className="user-center">
                                            <p className="font-s-25 font-t-title">{t('ugCont30')}</p>
                                            <img onClick={openDomesticGuidePopup} className="wd-30 ht-30 m-l-10 c-point m-b-5" src={commonGuide} alt="guide"/>
                                            <p className="font-t-cont font-s-13 m-l-3">({t('ugCont14')})</p>
                                        </div>
                                    </div>
                                    <div className="font-t-cont ug-proc-row" style={{height:"150px", display:"flex", alignItems:"center", justifyContent:"center", marginTop:"40px"}}>
                                        {/*절차1*/}
                                        <div>
                                            <div style={{width:"150px", minHeight:"150px"}}>
                                                <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                    <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideOne} alt="one"/>
                                                    <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc2} alt="process1"/>
                                                </div>
                                                <div className="user-center">
                                                    <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont31')}</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/*절차2*/}
                                        <div>
                                            <div style={{width:"150px", minHeight:"150px"}}>
                                                <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                    <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideTwo} alt="two"/>
                                                    <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc3} alt="process2"/>
                                                </div>
                                                <div className="user-center">
                                                    <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont23')}</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/*절차3*/}
                                        <div>
                                            <div style={{width:"150px", minHeight:"150px"}}>
                                                <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                    <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideThree} alt="three"/>
                                                    <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc7} alt="process3"/>
                                                </div>
                                                <div className="user-center">
                                                    <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont32')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*국내배송 가이드영역 (신규 UI 목업 + SVG 가이드)*/}
                                    <div className="cg-wrap">

                                        {/* ===== Step 1 : 국내배송신청 ===== */}
                                        <div className="cg-card">
                                            <div className="cg-step-head">
                                                <div className="cg-badge">1</div>
                                                <p className="cg-title">{t('dmS1Title')}</p>
                                            </div>
                                            <p className="cg-desc">{t('dmS1Desc')}</p>

                                            <div className="cg-sub-grid">
                                                {/* 1-1 헤더 [구매대행] → [국내배송신청] */}
                                                <div className="cg-sub">
                                                    <span className="cg-sub-tag">STEP 1-1</span>
                                                    <p className="cg-sub-cap">{t('dmS1aCap')}</p>
                                                    <div className="cg-mock">
                                                        <div className="cg-hd">
                                                            <span className="cg-hd-logo">Btorage</span>
                                                            <div className="cg-hd-nav">
                                                                <span className="cg-nav-item">{t('hdMenu1')}</span>
                                                                <span className="cg-nav-item">{t('hdMenu2')}</span>
                                                                <span className="cg-nav-item cg-nav-hot cg-pulse">{t('hdMenu3')}</span>
                                                                <span className="cg-nav-item">{t('hdMenu4')}</span>
                                                                <span className="cg-nav-item">{t('hdMenu5')}</span>
                                                            </div>
                                                            <span className="cg-nav-item cg-nav-ghost">{t('hdMypg')}</span>
                                                        </div>
                                                        <div style={{padding: "0 14px 14px"}}>
                                                            <div style={{display: "inline-flex", flexDirection: "column", gap: "6px", padding: "8px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                                <span className="cg-detail-btn cg-pulse">{t('hdSMenu9')}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cg-arrow">&#8595;</div>

                                                {/* 1-2 국내배송 서비스폼 */}
                                                <div className="cg-sub">
                                                    <span className="cg-sub-tag">STEP 1-2</span>
                                                    <p className="cg-sub-cap">{t('dmS1bCap')}</p>
                                                    <div className="cg-mock">
                                                        <div className="cg-mock-bar">
                                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('dmUiDomeFormTitle')}</span>
                                                        </div>
                                                        <div className="cg-mock-body">
                                                            <div className="cg-form">
                                                                <div className="cg-field full">
                                                                    <span className="cg-label">{t('ogUiProdName')}</span>
                                                                    <span className="cg-input">Wireless Earbuds</span>
                                                                </div>
                                                                <div className="cg-field">
                                                                    <span className="cg-label">{t('ogUiOption')}</span>
                                                                    <span className="cg-input">White</span>
                                                                </div>
                                                                <div className="cg-field">
                                                                    <span className="cg-label">{t('ogUiQty')}</span>
                                                                    <span className="cg-input">1</span>
                                                                </div>
                                                                <div className="cg-field">
                                                                    <span className="cg-label">{t('ogUiPrice')}</span>
                                                                    <span className="cg-input">&#8361; 89,000</span>
                                                                </div>
                                                                <div className="cg-field">
                                                                    <span className="cg-label">{t('ogUiShopFee')}</span>
                                                                    <span className="cg-input">&#8361; 3,000</span>
                                                                </div>
                                                                <div className="cg-field">
                                                                    <span className="cg-label">{t('dmUiFee')}</span>
                                                                    <span className="cg-input">&#8361; 6,440</span>
                                                                </div>
                                                                <div className="cg-field full">
                                                                    <span className="cg-label">{t('cgUiProdUrl')}</span>
                                                                    <span className="cg-input ph">https://shop.example.kr/product/456</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('dmS1Note')}</span></div>
                                                    </div>
                                                    <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('dmS1bNote')}</span></div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* ===== Step 2 : 상품금액결제 ===== */}
                                        <div className="cg-card">
                                            <div className="cg-step-head">
                                                <div className="cg-badge">2</div>
                                                <p className="cg-title">{t('dmS2Title')}</p>
                                            </div>
                                            <p className="cg-desc">{t('dmS2Desc')}</p>

                                            <div className="cg-sub-grid">
                                                <div className="cg-sub">
                                                    <span className="cg-sub-tag">STEP 2-1</span>
                                                    <p className="cg-sub-cap">{t('dmS2aCap')}</p>
                                                    <div className="cg-mock">
                                                        <div className="cg-mock-bar">
                                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayTitle')}</span>
                                                        </div>
                                                        <div className="cg-mock-body">
                                                            <div className="cg-pay-grid">
                                                                <div className="cg-pay-tile sel"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Global)</div>
                                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Korean)</div>
                                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>GlobalCard</div>
                                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>KoreanPay</div>
                                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#80;</div>Paypal</div>
                                                                <div className="cg-pay-tile"><div className="cg-pay-ico">&#8361;</div>{t('cgUiDeposit')}</div>
                                                            </div>
                                                            <div className="cg-btn-row">
                                                                <div className="cg-btn cg-btn-pay cg-pulse">Pay</div>
                                                                <div className="cg-btn cg-btn-save">Save</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('dmS2Note')}</span></div>
                                        </div>

                                        {/* ===== Step 3 : 한국주소로 출발 ===== */}
                                        <div className="cg-card">
                                            <div className="cg-step-head">
                                                <div className="cg-badge">3</div>
                                                <p className="cg-title">{t('dmS3Title')}</p>
                                            </div>
                                            <p className="cg-desc">{t('dmS3Desc')}</p>

                                            <div className="cg-sub-grid">
                                                <div className="cg-sub">
                                                    <span className="cg-sub-tag">STEP 3-1</span>
                                                    <p className="cg-sub-cap">{t('dmS3aCap')}</p>
                                                    <div className="cg-mock">
                                                        <div className="cg-mock-bar">
                                                            <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiShipListTitle')}</span>
                                                        </div>
                                                        <div className="cg-mock-body">
                                                            <div className="cg-list">
                                                                <div style={{padding: "13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                                    <div className="cg-row-sb">
                                                                        <span style={{fontSize: "13px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('dmUiKrCourier')} · CJ대한통운</span>
                                                                        <span className="cg-chip done">{t('cgUiShipDone')}</span>
                                                                    </div>
                                                                    <div className="cg-row-sb" style={{marginTop: "9px"}}>
                                                                        <span style={{fontSize: "12px", color: "var(--up-text-sub)"}}>{t('cgUiTrackNo')}</span>
                                                                        <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-brand-2)"}}>6812 3345 7789</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('dmS3Note')}</span></div>
                                        </div>

                                        {/* ===== Step 4 : 상품수령 (한국 택배차 SVG) ===== */}
                                        <div className="cg-card">
                                            <div className="cg-step-head">
                                                <div className="cg-badge">4</div>
                                                <p className="cg-title">{t('dmS4Title')}</p>
                                            </div>
                                            <p className="cg-desc">{t('dmS4Desc')}</p>
                                            <div style={{marginTop: "18px"}}>
                                                <RcvScene t={t}/>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                :
                                deliveryGuide ?
                                    // 배송대행가이드 내용
                                    <div>
                                        <div className="user-center ht-100 m-t-50 ug-proc-head" style={{borderBottom: "solid 1px var(--up-border)"}}>
                                            <div className="user-center">
                                                <p className="font-s-25 font-t-title">{t('ugCont33')}</p>
                                                <img onClick={openDeliveryGuidePopup} className="wd-30 ht-30 m-l-10 c-point m-b-5" src={commonGuide} alt="guide"/>
                                                <p className="font-t-cont font-s-13 m-l-3">({t('ugCont14')})</p>
                                            </div>
                                        </div>
                                        <div className="font-t-cont ug-proc-row" style={{height:"150px", display:"flex", alignItems:"center", justifyContent:"center", marginTop:"40px"}}>
                                            {/*절차1*/}
                                            <div>
                                                <div style={{width:"150px", minHeight:"150px"}}>
                                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideOne} alt="one"/>
                                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc8} alt="process1"/>
                                                    </div>
                                                    <div className="user-center">
                                                        <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont34')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*절차2*/}
                                            <div>
                                                <div style={{width:"150px", minHeight:"150px"}}>
                                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideTwo} alt="two"/>
                                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc2} alt="process2"/>
                                                    </div>
                                                    <div className="user-center">
                                                        <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont35')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*절차3*/}
                                            <div>
                                                <div style={{width:"150px", minHeight:"150px"}}>
                                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideThree} alt="three"/>
                                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc4} alt="process3"/>
                                                    </div>
                                                    <div className="user-center">
                                                        <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont17')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*절차4*/}
                                            <div>
                                                <div style={{width:"150px", minHeight:"150px"}}>
                                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideFour} alt="four"/>
                                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc3} alt="process4"/>
                                                    </div>
                                                    <div className="user-center">
                                                        <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont18')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*절차5*/}
                                            <div>
                                                <div style={{width:"150px", minHeight:"150px"}}>
                                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideFive} alt="five"/>
                                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc5} alt="process5"/>
                                                    </div>
                                                    <div className="user-center">
                                                        <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont19')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*절차6*/}
                                            <div>
                                                <div style={{width:"150px", minHeight:"150px"}}>
                                                    <div className="user-center" style={{height:"90px", position:"relative"}}>
                                                        <img style={{width:"22px", height:"22px", position:"absolute", top:"5px", left:"20px", opacity:"0.6", filter: "grayscale(100%) brightness(99%)"}} src={guideSix} alt="six"/>
                                                        <img style={{width:"60px", height:"60px", opacity:"0.7"}} src={guidePc6} alt="process6"/>
                                                    </div>
                                                    <div className="user-center">
                                                        <p style={{margin:"0", fontSize:"14px", color:"var(--up-text)", textAlign:"center"}}>{t('ugCont20')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*배송대행 가이드영역 (신규 UI 목업 + SVG 가이드)*/}
                                        <div className="cg-wrap">

                                            {/* ===== Step 1 : 물류센터로 주문 ===== */}
                                            <div className="cg-card">
                                                <div className="cg-step-head">
                                                    <div className="cg-badge">1</div>
                                                    <p className="cg-title">{t('dlS1Title')}</p>
                                                </div>
                                                <p className="cg-desc">{t('dlS1Desc')}</p>

                                                <div className="cg-sub-grid">
                                                    {/* 1-1 쇼핑몰 주문 (물류센터 주소 + 사서함번호 BT123) */}
                                                    <div className="cg-sub">
                                                        <span className="cg-sub-tag">STEP 1-1</span>
                                                        <p className="cg-sub-cap">{t('dlS1aCap')}</p>
                                                        <div className="cg-mock">
                                                            <div className="cg-mock-bar">
                                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('dlUiShopOrderTitle')}</span>
                                                            </div>
                                                            <div className="cg-mock-body">
                                                                <div className="cg-list" style={{marginBottom: "14px"}}>
                                                                    <div className="cg-row-sb" style={{padding: "10px 12px", border: "1px solid var(--up-border)", borderRadius: "9px", background: "var(--up-surface-2)"}}>
                                                                        <span style={{fontSize: "12.5px", color: "var(--up-text)"}}>Running Shoes / 270</span>
                                                                        <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>&#8361; 119,000</span>
                                                                    </div>
                                                                    <div className="cg-row-sb" style={{padding: "10px 12px", border: "1px solid var(--up-border)", borderRadius: "9px", background: "var(--up-surface-2)"}}>
                                                                        <span style={{fontSize: "12.5px", color: "var(--up-text)"}}>Cotton T-Shirt / Navy·L</span>
                                                                        <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>&#8361; 29,000</span>
                                                                    </div>
                                                                    <div className="cg-row-sb" style={{padding: "10px 12px", borderRadius: "9px", background: "var(--up-brand-soft)"}}>
                                                                        <span style={{fontSize: "12.5px", color: "var(--up-brand-2)", fontFamily: "'LINESeedKR-Bd', sans-serif"}}>{t('dlUiFinalPay')}</span>
                                                                        <span style={{fontSize: "14px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-brand-2)"}}>&#8361; 148,000</span>
                                                                    </div>
                                                                </div>
                                                                <div className="cg-form">
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('cgUiRecName')}</span>
                                                                        <span className="cg-input">Account Name</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('cgUiRecTel')}</span>
                                                                        <span className="cg-input">070-4131-4180</span>
                                                                    </div>
                                                                    <div className="cg-field full">
                                                                        <span className="cg-label">{t('cgUiRecAddr')}</span>
                                                                        <span className="cg-input ph">경기도 광주시 곤지암읍 연곡길42번길 32-15</span>
                                                                    </div>
                                                                    <div className="cg-field full">
                                                                        <span className="cg-label">{t('dlUiAddrDt')}</span>
                                                                        <span className="cg-input">1층
                                                                            <span style={{marginLeft: "8px", padding: "2px 9px", borderRadius: "6px", background: "var(--up-brand)", color: "#fff", fontFamily: "'LINESeedKR-Bd', sans-serif", fontSize: "12.5px"}}>BT123</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="cg-arrow">OR</div>

                                                    {/* 1-2 픽업신청 폼 */}
                                                    <div className="cg-sub">
                                                        <span className="cg-sub-tag">STEP 1-2</span>
                                                        <p className="cg-sub-cap">{t('dlS1bCap')}</p>
                                                        <div className="cg-mock">
                                                            <div className="cg-mock-bar">
                                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('smPickupBt')}</span>
                                                            </div>
                                                            <div className="cg-mock-body">
                                                                <div className="cg-form">
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('dlUiPickupName')}</span>
                                                                        <span className="cg-input">Account Name</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('cgUiRecTel')}</span>
                                                                        <span className="cg-input">010-3338-9354</span>
                                                                    </div>
                                                                    <div className="cg-field full">
                                                                        <span className="cg-label">{t('cgUiRecAddr')}</span>
                                                                        <span className="cg-input ph">경기도 광주시 곤지암읍 연곡길42번길 32-15</span>
                                                                    </div>
                                                                    <div className="cg-field full">
                                                                        <span className="cg-label">{t('dlUiAddrDt')}</span>
                                                                        <span className="cg-input">1층
                                                                            <span style={{marginLeft: "8px", padding: "2px 9px", borderRadius: "6px", background: "var(--up-brand)", color: "#fff", fontFamily: "'LINESeedKR-Bd', sans-serif", fontSize: "12.5px"}}>BT123</span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('upr10')}</span>
                                                                        <span className="cg-input">30</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('upr11')}</span>
                                                                        <span className="cg-input">20</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('upr12')}</span>
                                                                        <span className="cg-input">10</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('upr14')}</span>
                                                                        <span className="cg-input">5</span>
                                                                    </div>
                                                                </div>
                                                                <div className="cg-row-sb" style={{background: "var(--up-brand-soft)", borderRadius: "10px", padding: "11px 13px", marginTop: "12px"}}>
                                                                    <span style={{color: "var(--up-brand-2)", fontFamily: "'LINESeedKR-Bd', sans-serif", fontSize: "13px"}}>{t('upr16')}</span>
                                                                    <span style={{color: "var(--up-brand-2)", fontFamily: "'LINESeedKR-Bd', sans-serif", fontSize: "14px"}}>&#8361; 4,500</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('dlS1Note')}</span></div>
                                            </div>

                                            {/* ===== Step 2 : 배송대행신청 ===== */}
                                            <div className="cg-card">
                                                <div className="cg-step-head">
                                                    <div className="cg-badge">2</div>
                                                    <p className="cg-title">{t('dlS2Title')}</p>
                                                </div>
                                                <p className="cg-desc">{t('dlS2Desc')}</p>

                                                <div className="cg-sub-grid">
                                                    {/* 2-1 헤더 [배송대행] 메뉴 */}
                                                    <div className="cg-sub">
                                                        <span className="cg-sub-tag">STEP 2-1</span>
                                                        <p className="cg-sub-cap">{t('dlS2aCap')}</p>
                                                        <div className="cg-mock">
                                                            <div className="cg-hd">
                                                                <span className="cg-hd-logo">Btorage</span>
                                                                <div className="cg-hd-nav">
                                                                    <span className="cg-nav-item">{t('hdMenu1')}</span>
                                                                    <span className="cg-nav-item">{t('hdMenu2')}</span>
                                                                    <span className="cg-nav-item">{t('hdMenu3')}</span>
                                                                    <span className="cg-nav-item cg-nav-hot cg-pulse">{t('hdMenu4')}</span>
                                                                    <span className="cg-nav-item">{t('hdMenu5')}</span>
                                                                </div>
                                                                <span className="cg-nav-item cg-nav-ghost">{t('hdMypg')}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="cg-arrow">&#8595;</div>

                                                    {/* 2-2 배송대행 서비스폼 */}
                                                    <div className="cg-sub">
                                                        <span className="cg-sub-tag">STEP 2-2</span>
                                                        <p className="cg-sub-cap">{t('dlS2bCap')}</p>
                                                        <div className="cg-mock">
                                                            <div className="cg-mock-bar">
                                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('dlUiDelFormTitle')}</span>
                                                            </div>
                                                            <div className="cg-mock-body">
                                                                <div className="cg-form">
                                                                    <div className="cg-field full">
                                                                        <span className="cg-label">{t('dlUiCourier')}</span>
                                                                        <span className="cg-input cg-row-sb">CJ대한통운<span style={{color: "var(--up-text-faint)"}}>&#9662;</span></span>
                                                                    </div>
                                                                    <div className="cg-field full">
                                                                        <span className="cg-label">{t('dlUiGoodsName')}</span>
                                                                        <span className="cg-input">Sneakers Box</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('ogUiOption')}</span>
                                                                        <span className="cg-input">-</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('dlUiGoodsAmt')}</span>
                                                                        <span className="cg-input">&#8361; 119,000</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('dlUiTotalQtyBox')}</span>
                                                                        <span className="cg-input">3</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('cgUiTrackNo')}</span>
                                                                        <span className="cg-input">6812 3345 7789</span>
                                                                    </div>
                                                                </div>
                                                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('dlS2bNote')}</span></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('dlS2Note')}</span></div>
                                            </div>

                                            {/* ===== Step 3 : 해외배송비 청구 ===== */}
                                            <div className="cg-card">
                                                <div className="cg-step-head">
                                                    <div className="cg-badge">3</div>
                                                    <p className="cg-title">{t('dlS3Title')}</p>
                                                </div>
                                                <p className="cg-desc">{t('dlS3Desc')}</p>

                                                <div className="cg-sub-grid">
                                                    {/* 3-1 [MyPg] */}
                                                    <div className="cg-sub">
                                                        <span className="cg-sub-tag">STEP 3-1</span>
                                                        <p className="cg-sub-cap">{t('dlS3aCap')}</p>
                                                        <div className="cg-mock">
                                                            <div className="cg-hd">
                                                                <span className="cg-hd-logo">Btorage</span>
                                                                <div className="cg-hd-nav">
                                                                    <span className="cg-nav-item">{t('hdMenu1')}</span>
                                                                    <span className="cg-nav-item">{t('hdMenu2')}</span>
                                                                    <span className="cg-nav-item">{t('hdMenu3')}</span>
                                                                    <span className="cg-nav-item">{t('hdMenu4')}</span>
                                                                </div>
                                                                <span className="cg-nav-item cg-nav-hot cg-pulse">{t('hdMypg')}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="cg-arrow">&#8595;</div>

                                                    {/* 3-2 배송사별 해외배송료 목록 [상세] */}
                                                    <div className="cg-sub">
                                                        <span className="cg-sub-tag">STEP 3-2</span>
                                                        <p className="cg-sub-cap">{t('dlS3bCap')}</p>
                                                        <div className="cg-mock">
                                                            <div className="cg-mock-bar">
                                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiShipFeeTitle')}</span>
                                                            </div>
                                                            <div className="cg-mock-body">
                                                                <div className="cg-list">
                                                                    <div className="cg-row-sb" style={{padding: "11px 13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                                        <span style={{fontSize: "13px", color: "var(--up-text)"}}>BT2507-0130 · Box A</span>
                                                                        <span className="cg-detail-btn cg-pulse">{t('cgUiDetail')}</span>
                                                                    </div>
                                                                    <div className="cg-row-sb" style={{padding: "11px 13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                                        <span style={{fontSize: "13px", color: "var(--up-text)"}}>BT2507-0130 · Box B</span>
                                                                        <span className="cg-detail-btn cg-pulse">{t('cgUiDetail')}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="cg-arrow">&#8595;</div>

                                                    {/* 3-3 수취인정보 / 세관신고&보험 */}
                                                    <div className="cg-sub">
                                                        <span className="cg-sub-tag">STEP 3-3</span>
                                                        <p className="cg-sub-cap">{t('dlS3cCap')}</p>
                                                        <div className="cg-mock">
                                                            <div className="cg-mock-bar">
                                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiReceiver')} · {t('cgUiCustoms')}</span>
                                                            </div>
                                                            <div className="cg-mock-body">
                                                                <div className="cg-form">
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('cgUiRecName')}</span>
                                                                        <span className="cg-input">John Doe</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('cgUiRecTel')}</span>
                                                                        <span className="cg-input">+1 202-555-0147</span>
                                                                    </div>
                                                                    <div className="cg-field full">
                                                                        <span className="cg-label">{t('cgUiRecAddr')}</span>
                                                                        <span className="cg-input ph">1600 Pennsylvania Ave NW, Washington</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('cgUiDeclare')}</span>
                                                                        <span className="cg-input">USD 120</span>
                                                                    </div>
                                                                    <div className="cg-field">
                                                                        <span className="cg-label">{t('cgUiInsurance')}</span>
                                                                        <span className="cg-input">ON</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('dlS3Note')}</span></div>
                                            </div>

                                            {/* ===== Step 4 : 해외배송비 결제 ===== */}
                                            <div className="cg-card">
                                                <div className="cg-step-head">
                                                    <div className="cg-badge">4</div>
                                                    <p className="cg-title">{t('dlS4Title')}</p>
                                                </div>
                                                <p className="cg-desc">{t('dlS4Desc')}</p>

                                                <div className="cg-sub-grid">
                                                    {/* 4-1 결제목록 배송사 비교견적 */}
                                                    <div className="cg-sub">
                                                        <span className="cg-sub-tag">STEP 4-1</span>
                                                        <p className="cg-sub-cap">{t('dlS4aCap')}</p>
                                                        <div className="cg-mock">
                                                            <div className="cg-mock-bar">
                                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayListTitle')}</span>
                                                            </div>
                                                            <div className="cg-mock-body">
                                                                <div className="cg-list">
                                                                    <div className="cg-carrier sel">
                                                                        <span className="cg-carrier-logo">FedEx</span>
                                                                        <span className="cg-carrier-price">&#8361; 62,400</span>
                                                                        <span className="cg-carrier-meta"><span>{t('cgUiTime')} 3-5d</span><span>{t('cgUiOut')} 128</span></span>
                                                                    </div>
                                                                    <div className="cg-carrier">
                                                                        <span className="cg-carrier-logo">UPS</span>
                                                                        <span className="cg-carrier-price">&#8361; 60,100</span>
                                                                        <span className="cg-carrier-meta"><span>{t('cgUiTime')} 3-5d</span><span>{t('cgUiOut')} 74</span></span>
                                                                    </div>
                                                                    <div className="cg-carrier">
                                                                        <span className="cg-carrier-logo">EMS</span>
                                                                        <span className="cg-carrier-price">&#8361; 48,300</span>
                                                                        <span className="cg-carrier-meta"><span>{t('cgUiTime')} 7-12d</span><span>{t('cgUiOut')} 210</span></span>
                                                                    </div>
                                                                    <div className="cg-carrier">
                                                                        <span className="cg-carrier-logo">K-Packet</span>
                                                                        <span className="cg-carrier-price">&#8361; 33,700</span>
                                                                        <span className="cg-carrier-meta"><span>{t('cgUiTime')} 10-16d</span><span>{t('cgUiOut')} 305</span></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="cg-arrow">&#8595;</div>

                                                    {/* 4-2 결제수단 선택 후 Pay */}
                                                    <div className="cg-sub">
                                                        <span className="cg-sub-tag">STEP 4-2</span>
                                                        <p className="cg-sub-cap">{t('dlS4bCap')}</p>
                                                        <div className="cg-mock">
                                                            <div className="cg-mock-bar">
                                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiPayTitle')}</span>
                                                            </div>
                                                            <div className="cg-mock-body">
                                                                <div className="cg-pay-grid">
                                                                    <div className="cg-pay-tile sel"><div className="cg-pay-ico">&#128179;</div>BtoragePay<br/>(Global)</div>
                                                                    <div className="cg-pay-tile"><div className="cg-pay-ico">&#128179;</div>GlobalCard</div>
                                                                    <div className="cg-pay-tile"><div className="cg-pay-ico">&#80;</div>Paypal</div>
                                                                </div>
                                                                <div className="cg-btn-row">
                                                                    <div className="cg-btn cg-btn-pay cg-pulse">Pay</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('dlS4Note')}</span></div>
                                            </div>

                                            {/* ===== Step 5 : 해외로 출발 ===== */}
                                            <div className="cg-card">
                                                <div className="cg-step-head">
                                                    <div className="cg-badge">5</div>
                                                    <p className="cg-title">{t('dlS5Title')}</p>
                                                </div>
                                                <p className="cg-desc">{t('dlS5Desc')}</p>

                                                <div className="cg-sub-grid">
                                                    <div className="cg-sub">
                                                        <span className="cg-sub-tag">STEP 5-1</span>
                                                        <p className="cg-sub-cap">{t('dlS5aCap')}</p>
                                                        <div className="cg-mock">
                                                            <div className="cg-mock-bar">
                                                                <span className="cg-dot" style={{background: "var(--up-brand)"}}/>
                                                                <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>{t('cgUiShipListTitle')}</span>
                                                            </div>
                                                            <div className="cg-mock-body">
                                                                <div className="cg-list">
                                                                    <div style={{padding: "13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                                        <div className="cg-row-sb">
                                                                            <span style={{fontSize: "13px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>Box A · FedEx</span>
                                                                            <span className="cg-chip done">{t('cgUiShipDone')}</span>
                                                                        </div>
                                                                        <div className="cg-row-sb" style={{marginTop: "9px"}}>
                                                                            <span style={{fontSize: "12px", color: "var(--up-text-sub)"}}>{t('cgUiTrackNo')}</span>
                                                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-brand-2)"}}>7749 1023 8865</span>
                                                                        </div>
                                                                    </div>
                                                                    <div style={{padding: "13px", border: "1px solid var(--up-border)", borderRadius: "10px", background: "var(--up-surface-2)"}}>
                                                                        <div className="cg-row-sb">
                                                                            <span style={{fontSize: "13px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-text)"}}>Box B · EMS</span>
                                                                            <span className="cg-chip done">{t('cgUiShipDone')}</span>
                                                                        </div>
                                                                        <div className="cg-row-sb" style={{marginTop: "9px"}}>
                                                                            <span style={{fontSize: "12px", color: "var(--up-text-sub)"}}>{t('cgUiTrackNo')}</span>
                                                                            <span style={{fontSize: "12.5px", fontFamily: "'LINESeedKR-Bd', sans-serif", color: "var(--up-brand-2)"}}>EE 0345 1180 KR</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="cg-note"><b>&#8251; {t('cgNoteLabel')}</b><span>{t('cgS5Note')}</span></div>
                                            </div>

                                            {/* ===== Step 6 : 상품수령 ===== */}
                                            <div className="cg-card">
                                                <div className="cg-step-head">
                                                    <div className="cg-badge">6</div>
                                                    <p className="cg-title">{t('cgS6Title')}</p>
                                                </div>
                                                <p className="cg-desc">{t('cgS6Desc')}</p>
                                                <div style={{marginTop: "18px"}}>
                                                    <RcvScene t={t}/>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    :
                                    null
            }
            { cartGuidePopup ?
                <GuideModal cartGuidePopup={cartGuidePopup} closeCartGuidePopup={closeCartGuidePopup}
                            cartGuideHeader={cartGuideHeader} cartGuideContent={cartGuideContent}/>
                :
                orderGuidePopup ?
                    <GuideModal orderGuidePopup={orderGuidePopup} closeOrderGuidePopup={closeOrderGuidePopup}
                                orderGuideHeader={orderGuideHeader} orderGuideContent={orderGuideContent}/>
                    :
                    offlineGuidePopup ?
                        <GuideModal offlineGuidePopup={offlineGuidePopup} closeOfflineGuidePopup={closeOfflineGuidePopup}
                                    offlineGuideHeader={offlineGuideHeader} offlineGuideContent={offlineGuideContent}/>
                        :
                        transferGuidePopup ?
                            <GuideModal transferGuidePopup={transferGuidePopup} closeTransferGuidePopup={closeTransferGuidePopup}
                                        transferGuideHeader={transferGuideHeader} transferGuideContent={transferGuideContent}/>
                            :
                            domesticGuidePopup ?
                                <GuideModal domesticGuidePopup={domesticGuidePopup} closeDomesticGuidePopup={closeDomesticGuidePopup}
                                            domesticGuideHeader={domesticGuideHeader} domesticGuideContent={domesticGuideContent}/>
                                :
                                deliveryGuidePopup ?
                                    <GuideModal deliveryGuidePopup={deliveryGuidePopup} closeDeliveryGuidePopup={closeDeliveryGuidePopup}
                                                deliveryGuideHeader={deliveryGuideHeader} deliveryGuideContent={deliveryGuideContent}/>
                                    :
                                    null
            }
        </div>
    )
}

export default UserUsageGuidePg
